/*
 * BL-washbasin-selector-v3.js · "grouping de lavabos" en la PDP del mueble (refresh PDP-native).
 * Base = clon v2 (tabs underline + slider + controles). Panel desplegable (Color · Senos · Faldón ·
 * Grifo) con chips solo-icono (iconos del metaobject). color/grosor/senos cambian la HERO del mueble
 * (basinImages) + la card + el sticky-atc; disponibilidad por talla (p.ej. 2 senos NO en 60cm);
 * 2026-07-30: universo de chips = UNIÓN de los juegos per-lavabo (ya no un lavabo de muestra) →
 * familias con juegos distintos conviven; chip no ofrecido por el modelo activo = deshabilitado,
 * pill de modelo incompatible con la selección = atenuada pero clicable (re-marca a su 1ª válida);
 * resuelve variante (Breite=talla mueble · Schürze · Hahnloch). En móvil: botón Preview (pop-up espejo
 * de la galería principal: mini-swiper scroll-snap con las slides vivas de media-gallery + dots).
 * V4 (2026-07-04, spec Victor): fila de MODOS ohne/mit/nur-Waschtischplatte. ohne = swiper escaparate
 * (click en card → mit + selección); mit = pills modelos + auto-select 1º + panel; top = swatches de
 * color de encimera + 1 card (data.tops desde furniture_allowed_tops; variante por talla del mueble).
 * Precio total de la configuración (acuerdo 2026-06-30): línea bajo el selector (solo desktop) con
 * mueble+addons; se desvanece cuando el sticky ATC está visible (toggle del bloque para desactivarlo).
 * 2026-08-31: COLOR DE ARRANQUE por lavabo = el del propio mueble si ese lavabo lo tiene, blanco si
 * no (data.furnitureColor -> DEFAULT_COLOR / defaultColorFor). Antes arrancaba siempre en blanco.
 * 2026-09-10: PUENTE DE SENOS. El chip "1/2 Becken" que este mueble no ofrece se habilita si un
 * hermano de la misma línea Y la misma configuración del cuerpo (data.bridges + data.drawer, emitidos
 * por el snippet) lo ofrece en la Breite activa; al pulsarlo se hace el swap del grouping a ese
 * producto (BLProductGrouping.navigate) con la selección persistida (senos incluido) para que el
 * hermano arranque ya en "mit Waschtisch". Otras configuraciones (bundle 60+60) van por el grouping.
 * 2026-10-27 · BL-074: MUEBLE OBLIGADO (data.required = custom.furniture_basin_required): sin «Sin
 * lavabo», arranque con el 1er lavabo vendible, botón bloqueado sin lavabo válido y red en el
 * /cart/add (installRequiredGuard). Pruebas: tools/wb3-required-harness.js.
 * 2026-11-02 · BL-125: modo 'overtop' «Mit Aufsatzwaschbecken» (data.overtop + data.topIncluded,
 * campos custom.furniture_allowed_overtop_basins + custom.furniture_top_included): cards con foto,
 * modelo, precio y ficha, sin panel; variante por la medida del mueble; fotos "<color>|aufsatz" del
 * mapa de siempre; viaja al carrito como lavabo (_is_washbasin). Con la tapa incluida no hay «Nur
 * Waschtischplatte». Pruebas: tools/wb3-overtop-harness.js.
 * Node: { senosNum, findWb, variantKey, optAvailable, addedVariantIds, requiredBlock }.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') api.__boot(window, document);
})(this, function () {
  'use strict';

  var SWHEX = { weiss: '#f1efe9', taupe: '#c9b8a4' };

  function senosNum(w) { return (w && w.senos && w.senos.value === 'basin-double') ? 2 : 1; }
  function findWb(list, model, color, senos) {
    return (list || []).find(function (w) { return w.model === model && w.color && w.color.value === color && senosNum(w) === senos; }) || null;
  }
  // clave de variante con tokens ESTABLES (no traducibles): talla|grosor|grifo(con/sin)
  // grosor = key del metaobjeto basin_thickness (2/6/10/...); nº abierto, no enumerar
  function variantKey(size, thKey, tapKey) { return size + '|' + thKey + '|' + tapKey; }
  // pure availability check (size-aware) — exported for tests
  function optAvailable(list, trial, size) {
    if (!size) return true;
    var wb = findWb(list, trial.model, trial.color, trial.senos);
    var v = wb ? wb.variants[variantKey(size, trial.thKey, trial.tapKey)] : null;
    return !!(v && v.available !== false);
  }
  // 2026-10-27 · BL-074: ids de variante que pide un /cart/add — FormData del formulario del tema o
  // JSON {id} / {items:[{id}]}, que es lo que mandan los providers. Puro, exportado para el arnés.
  function addedVariantIds(body) {
    var ids = [];
    if (!body) return ids;
    if (typeof FormData !== 'undefined' && body instanceof FormData) { var fid = body.get('id'); if (fid) ids.push(String(fid)); return ids; }
    if (typeof body === 'string') {
      var b; try { b = JSON.parse(body); } catch (e) { return ids; }
      if (b && b.id) ids.push(String(b.id));
      if (b && Array.isArray(b.items)) b.items.forEach(function (it) { if (it && it.id) ids.push(String(it.id)); });
    }
    return ids;
  }
  // ¿el añadido lleva un mueble obligado SIN ninguno de sus lavabos/encimeras? → texto del bloqueo.
  // registry = { <productId>: { furn: {variantId:1}, ok: {variantId:1}, msg } }
  function requiredBlock(registry, body) {
    if (!registry) return null;
    var ids = addedVariantIds(body); if (!ids.length) return null;
    var keys = Object.keys(registry);
    for (var i = 0; i < keys.length; i++) {
      var r = registry[keys[i]];
      if (!r || !r.furn || !ids.some(function (id) { return r.furn[id]; })) continue;
      if (!ids.some(function (id) { return r.ok && r.ok[id]; })) return r.msg || 'Basin required';
    }
    return null;
  }

  function __boot(win, doc) {
    // BL-074: red del mueble obligado. Envuelve el fetch ORIGINAL del interceptor de /cart/add
    // (reg.originalFetch, compartido por sus 4 copias), así ve el cuerpo YA montado por los providers
    // (mueble + lavabo) o el del formulario tal cual cuando ningún provider inyectó nada (mueble
    // solo). Un mueble obligado sin ninguno de sus lavabos/encimeras recibe la respuesta de error de
    // Shopify (422 + description) y el formulario del tema pinta el aviso en su línea de error. Es la
    // red: el camino normal ya lo corta syncRequiredAtc deshabilitando el botón.
    function installRequiredGuard(reg) {
      win.__blWb3Required = win.__blWb3Required || {};
      if (reg.requiredGuard) return;
      reg.requiredGuard = true;
      var inner = reg.originalFetch;
      reg.originalFetch = function (url, config) {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (u.indexOf('/cart/add') < 0 || !config) return inner.apply(this, arguments);
        var msg = null;
        try { msg = requiredBlock(win.__blWb3Required, config.body); } catch (e) { msg = null; }
        var R = win.Response || (typeof Response !== 'undefined' ? Response : null);
        if (!msg || !R) return inner.apply(this, arguments);
        return Promise.resolve(new R(JSON.stringify({ status: 422, message: msg, description: msg }), { status: 422, headers: { 'Content-Type': 'application/json' } }));
      };
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function uniqBy(a, k) { var seen = {}, o = []; a.forEach(function (x) { if (x && !seen[x[k]]) { seen[x[k]] = 1; o.push(x); } }); return o; }
    function fmtCents(c) { try { return new Intl.NumberFormat(doc.documentElement.lang || 'de-DE', { style: 'currency', currency: (win.Shopify && win.Shopify.currency && win.Shopify.currency.active) || 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(0) + ' €'; } }
    function firstDigit(arr) { for (var i = 0; i < arr.length; i++) { var v = (arr[i] || '').trim(); if (/^\d/.test(v)) return v; } return null; }
    function readSize() {
      var scope = doc.querySelector('product-info') || doc;
      // 1) control de talla EN VIVO (el desplegable que el usuario ve) — autoritativo aunque la variante/selected-variant
      //    quede stale tras un swap del grouping (que cachea secciones)
      var cands = [];
      scope.querySelectorAll('variant-selects select, .product-form__input select').forEach(function (s) { cands.push(s.value); });
      scope.querySelectorAll('variant-selects input:checked, .product-form__input input:checked').forEach(function (i) { cands.push(i.value); });
      var live = firstDigit(cands);
      if (live) return live;
      // 2) fallback: variante seleccionada del tema
      var selEl = scope.querySelector('variant-selects [data-selected-variant], [data-selected-variant]');
      if (selEl) { try { var sv = JSON.parse(selEl.textContent || '{}'); if (sv && sv.options) return firstDigit(sv.options); } catch (e) {} }
      return null;
    }

    // 2026-08-24 · BLOCKER pre-live: en los muebles v3 el server anexa TODOS los sets de combos
    // detras de las curadas (para que el swap tenga slides vivas) y el recorte inicial es 100% JS.
    // Si el init aborta (JSON roto / 0 lavabos publicables en el market) nadie recortaba y la PDP
    // mostraba la galeria entera (~30 slides). Recorte de emergencia AUTONOMO: lee las curadas del
    // atributo data-bl-curated del root (independiente del JSON grande) y PODA las slides/thumbs
    // anexadas. Con reintentos: media-gallery inicializa en diferido (Motion.inView) y puede
    // resucitar slides desde sus caches; cada pasada re-poda y sincroniza elements.mediaItems.
    function emergencyCuratedTrim(root) {
      var rootCsv = (root && root.getAttribute('data-bl-curated')) || '';
      var attempts = 0;
      var run = function () {
        attempts++;
        doc.querySelectorAll('media-gallery').forEach(function (g) {
          try {
            // El atributo del gallery ya viene validado por Liquid. El del root es solo compatibilidad
            // con HTML cacheado anterior a este hardening.
            var csv = g.getAttribute('data-bl-initial-media-ids') || rootCsv;
            var want = csv.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
            var byId = {};
            var slides = Array.prototype.slice.call(g.querySelectorAll('.product__media-item[data-media-id]'));
            if (!slides.length) return;
            slides.forEach(function (el) { byId[String(el.getAttribute('data-media-id'))] = el; });
            var chosen = want.map(function (id) { return byId[id]; }).filter(Boolean);
            // Ultima barrera: si ambos atributos faltan/estan stale, nunca conservar la galeria
            // completa. El orden server-side garantiza que las cuatro primeras son el fallback real.
            if (!chosen.length) chosen = slides.slice(0, 4);
            var chosenIds = chosen.map(function (el) { return String(el.getAttribute('data-media-id')); });
            chosen.forEach(function (el) { el.classList.remove('bl-v3-gallery-supplemental'); el.removeAttribute('hidden'); });
            slides.forEach(function (el) { if (chosen.indexOf(el) < 0 && el.parentNode) el.parentNode.removeChild(el); });
            Array.prototype.slice.call(g.querySelectorAll('.product__thumbs-item[data-target]')).forEach(function (el) {
              if (chosenIds.indexOf(String(el.getAttribute('data-target'))) < 0 && el.parentNode) el.parentNode.removeChild(el);
              else { el.classList.remove('bl-v3-gallery-supplemental'); el.removeAttribute('hidden'); }
            });
            if (g.elements && g.elements.mediaItems && g.elements.mediaItems.length) g.elements.mediaItems = chosen.slice();
          } catch (e) {}
        });
        if (attempts < 6) win.setTimeout(run, 450);
      };
      run();
    }

    function init() {
      var dataEl = doc.getElementById('bl-wb-v3-data'); var root = doc.querySelector('[data-bl-wb3]');
      // 2026-07-29: swap del grouping a una PDP SIN selector v3 (p.ej. v3→v2, template distinto) →
      // limpiar la selección viva para que ningún provider residual siga inyectando el lavabo del
      // producto anterior en /cart/add (el "producto anclado" del QA bordeaux). __blWb3Selection
      // (memoria por sección) se conserva para restaurar al volver.
      if (!root) { win.__blWb3 = null; return; }
      if (!dataEl || root.dataset.blBound === '1') return;
      root.dataset.blBound = '1';
      // 2026-07-28: JSON roto o 0 lavabos completos (gate del snippet) → ocultar el bloque entero,
      // no dejar el esqueleto (heading + filas vacias) colgando en la PDP
      // 2026-08-24: los aborts YA NO dejan la galeria entera sin recortar (BLOCKER de la auditoria
      // pre-live) — antes de retirarse, se poda a las vistas curadas via emergencyCuratedTrim
      var data; try { data = JSON.parse(dataEl.textContent || '{}'); } catch (e) { root.style.display = 'none'; emergencyCuratedTrim(root); return; }
      // 2026-11-02 · BL-125: LAVABO SOBRE ENCIMERA (modo 'overtop', «Mit Aufsatzwaschbecken»). Llega
      // en data.overtop solo si el mueble tiene custom.furniture_allowed_overtop_basins Y
      // custom.furniture_top_included; un mueble así puede no tener ningún lavabo encastrado, así que el
      // bloque ya no se retira por wbs vacío sino solo si tampoco hay lavabos sobre encimera.
      // Con la tapa incluida (topIncluded) no se ofrece «Nur Waschtischplatte»: tops se vacía y todo
      // el motor de encimeras queda inerte. Sin los dos campos, todo igual.
      var wbs = data.washbasins || [];
      var OVERTOP = (data.overtop || []).filter(function (o) { return o && o.handle && o.variants; });
      if (!wbs.length && !OVERTOP.length) { root.style.display = 'none'; emergencyCuratedTrim(root); return; }
      var TOP_INCLUDED = data.topIncluded === true;
      var tops = TOP_INCLUDED ? [] : (data.tops || []);
      // 2026-10-27 · BL-074: mueble que se vende SIEMPRE con lavabo (custom.furniture_basin_required).
      // Sin «Sin lavabo», arranque con el primer lavabo vendible y botón bloqueado si no hay lavabo
      // ni encimera válidos (syncRequiredAtc + installRequiredGuard). Sin el campo, todo igual.
      var REQ = data.required === true;

      var models = []; wbs.forEach(function (w) { if (models.indexOf(w.model) < 0) models.push(w.model); });
      var colors = uniqBy(wbs.map(function (w) { return w.color; }).filter(Boolean), 'value');
      // 2026-08-31 · COLOR DE ARRANQUE = el del PROPIO mueble cuando el lavabo lo ofrece; si no, blanco.
      // Antes era colors[0], es decir el orden en que el PIM escribe furniture_allowed_basins (en la
      // practica siempre 'weiss'), asi que un mueble taupe abria el escaparate con los CINCO lavabos en
      // blanco aunque Ardelia y Meira existan en taupe. Es la misma regla que ya tenian las encimeras
      // (defaultTop) y el candado de color del snippet: un mueble solo juega a blanco + su color.
      // El handle viene del metaobjeto (custom.color_main), NUNCA del handle del producto: el mueble
      // 'kitami-gruen' tiene el color 'kitami-grun' y por texto no casarian.
      var FURN_COLOR = data.furnitureColor || '';
      function colorOffered(v) { return !!v && colors.some(function (c) { return c.value === v; }); }
      var DEFAULT_COLOR = (colorOffered(FURN_COLOR) && FURN_COLOR) ||
                          (colorOffered('weiss') && 'weiss') ||
                          (colors[0] && colors[0].value);
      // ...y POR MODELO para las cards del escaparate: en un mueble taupe, Ardelia y Meira abren en
      // taupe y Nivara/Toren/Tayla —que solo existen en blanco— se quedan en blanco. Sin esto, un
      // unico color global pintaba de taupe cards que no lo tienen (y caian a una foto cualquiera).
      function modelHasColor(m, v) {
        return !!v && wbs.some(function (w) { return w.model === m && w.color && w.color.value === v; });
      }
      function defaultColorFor(m) {
        // la eleccion del cliente (colorPref) manda sobre el color del mueble: si pide blanco, las
        // cards que aun no tienen memoria propia no pueden seguir anunciandose en taupe.
        var want = st.colorPref || FURN_COLOR;
        if (modelHasColor(m, want)) return want;
        if (modelHasColor(m, 'weiss')) return 'weiss';
        return DEFAULT_COLOR;
      }
      var senos = uniqBy(wbs.map(function (w) { return { value: senosNum(w), name: w.senos && w.senos.name, icon: w.senos && w.senos.icon }; }), 'value');
      senos.sort(function (a, b) { return a.value - b.value; });   // siempre 1 seno antes que 2
      // 2026-07-30: universo de chips = UNIÓN de los juegos per-lavabo (variant_5th/6th), ya no un
      // lavabo de muestra — permite mezclar familias con juegos distintos (p.ej. Ardelia solo-6 +
      // Tayla 2/10). Solo se renderiza lo que ALGÚN lavabo del mueble ofrece; lo que el modelo
      // activo no ofrece queda deshabilitado vía avail() (motor de combos, más abajo).
      var thicknesses = uniqBy(wbs.reduce(function (a, w) { return a.concat(w.thicknesses || []); }, []), 'key');
      var tapholes = uniqBy(wbs.reduce(function (a, w) { return a.concat(w.tapholes || []); }, []), 'key');
      // 2026-08-06: el universo de pills es el del GROUPING, no solo el de este mueble. Sin esto,
      // al pasar a 4 cajones desaparecía "1 Becken" en vez de quedar apagada, y el cliente concluía
      // que Zuri no lo hace. `groupingAxes` (render-set) lo emite el snippet recorriendo los
      // hermanos; lo que este mueble no ofrezca cae solo en `disabled` porque avail() sigue
      // midiendo contra `wbs` (enabled-set) — findWb devuelve null y optAvailable da false.
      // Los propios primero: uniqBy conserva la 1ª aparición, así que el nombre/icono locales
      // ganan y del grouping solo entran las que faltaban.
      // ⚠️ EL COLOR NO SE FUSIONA a propósito: cada mueble resuelve a blanco + su propio color.
      var gx = data.groupingAxes || {};
      senos = uniqBy(senos.concat(gx.senos || []), 'value');
      thicknesses = uniqBy(thicknesses.concat(gx.thicknesses || []), 'key');
      tapholes = uniqBy(tapholes.concat(gx.tapholes || []), 'key');
      senos.sort(function (a, b) { return a.value - b.value; });
      thicknesses.sort(function (a, b) { return (parseFloat(a.key) || 0) - (parseFloat(b.key) || 0); });
      // 2026-09-10 · PUENTE DE SENOS. Un mueble monta lavabos de 1 seno O de 2, nunca ambos (el de 2
      // senos es otro SKU: otro armario de 120, o dos de 60/70/80 en el bundle de 4 cajones), así que
      // "2 Becken" nunca podía resolverse aquí dentro y el chip vivía apagado. `data.bridges` (snippet)
      // lista los hermanos de la MISMA línea del grouping (color + tirador) con los senos que ofrecen
      // y sus tallas vendibles. Regla: el chip se habilita si un hermano lo ofrece en la Breite ACTIVA
      // (la del plan v3: «2 senos sale gris en tallas incompatibles»); pulsarlo = swap del grouping a
      // ese hermano, que arranca con la selección persistida (senos incluido, ver bridgeTo).
      // Solo entra cuando NINGÚN lavabo local ofrece ese valor: si un modelo local lo tiene, manda la
      // regla de siempre (chip por modelo activo).
      // MODELO (Víctor, 10-09): a 120 conviven TRES muebles distintos — 2 cajones + 1 seno, 2 cajones +
      // 2 senos y el bundle 60+60 (4 cajones) + 2 senos —, y vendrán seno izquierda/derecha, 2 cajones +
      // 1 puerta… Regla general: color, tirador y CONFIGURACIÓN DEL CUERPO (cajones/puertas/bundle) son
      // del grouping; la DISPOSICIÓN DEL SENO (nº y, mañana, posición) es del panel y solo salta entre
      // productos de la MISMA configuración (`data.drawer` = eje 3). El bundle 60+60 no es «2 senos del
      // de 2 cajones»: es otra configuración y se llega a él por la fila Konfiguration del grouping.
      // Sin eje 3 propio (dato incompleto) no se filtra, para no dejar un puente muerto.
      var BRIDGES = (data.bridges || []).filter(function (b) { return b && b.url && b.sizes && b.senos; });
      var DRAWER = data.drawer || '';
      function localOffers(senosVal) { return wbs.some(function (w) { return senosNum(w) === senosVal; }); }
      function bridgeFor(senosVal, size) {
        if (!size) return null;   // sin talla conocida no hay destino garantizado: mejor apagado
        var cs = BRIDGES.filter(function (b) {
          if (DRAWER && b.drawer !== DRAWER) return false;   // misma configuración del cuerpo, estricto
          if (b.senos.indexOf(senosVal) < 0) return false;
          var v = b.sizes[size];
          return !!(v && v.available !== false);
        });
        return cs[0] || null;   // varios = dato ambiguo; el primero en orden de familia, como el grouping
      }
      function bridgeable(senosVal, size) { return !localOffers(senosVal) && !!bridgeFor(senosVal, size); }
      // títulos desde settings/locales; el fallback defensivo coincide con el idioma base (alemán)
      var TITLES = {
        color: root.getAttribute('data-label-color') || 'Farbe',
        senos: root.getAttribute('data-label-senos') || 'Becken',
        thick: root.getAttribute('data-label-thick') || 'Schürze',
        tap: root.getAttribute('data-label-tap') || 'Hahnloch'
      };
      // 2026-08-21 (toggles de UI): `hide_senos` / `hide_tap` del bloque ocultan los chips de Senos
      // y de Orificio en el panel. El motor NO cambia: el eje oculto se fuerza a su valor canónico y
      // los demás se reconcilian alrededor (applyForced), así que variante, galería, addons y bundle
      // siguen resolviendo igual. Con los dos activos la fila 2 desaparece entera.
      var HIDE = { senos: root.getAttribute('data-hide-senos') === 'true',
                   tap: root.getAttribute('data-hide-tap') === 'true' };
      var FORCED = { senos: 1, tapKey: 'con' };   // 1 seno · con orificio (decisión 2026-08-21)
      // 2026-07-30: los textos "Nicht verfügbar für …" ya no se leen (ver resolve); los atributos
      // data-text-unavailable-* del snippet se conservan por si se reactivara el aviso.
      var I18N = {
        close: root.getAttribute('data-label-close') || 'Schließen',
        previous: root.getAttribute('data-label-previous') || 'Zurück',
        next: root.getAttribute('data-label-next') || 'Weiter',
        detailsShow: root.getAttribute('data-label-details-show') || 'Mehr Details',
        detailsHide: root.getAttribute('data-label-details-hide') || 'Weniger anzeigen'
      };

      // 2026-07-31: la tapa por defecto es la BLANCA, no la primera de la lista. Un mueble solo
      // ofrece blanco + su propio color (regla de Luis), y el blanco es el neutro de arranque igual
      // que en lavabos. Sin depender del orden en que el PIM escriba furniture_allowed_tops.
      var defaultTop = tops.find(function (t) { return t.color && t.color.value === 'weiss'; }) || tops[0];

      // V4: mode = 'none' (escaparate) | 'basin' (mit Waschtisch) | 'top' (nur Waschtischplatte)
      //     | 'overtop' (mit Aufsatzwaschbecken, BL-125; st.overtop = handle del lavabo elegido)
      // 2026-08-25: `colorPref` = color que el usuario ELIGIÓ, separado de `color` (el RESUELTO que se
      // pinta/monta). Solo lo cambia un click en un swatch, nunca la reconciliación. Sin esto, pasar de
      // un modelo bordeaux (Ardelia/Meira) a uno que solo existe en blanco (Tayla/Toren) machacaba
      // st.color a 'weiss' y al volver ya no había memoria del bordeaux: el color se "reseteaba".
      var st = { mode: 'none', model: null, top: defaultTop && defaultTop.handle,
                 color: DEFAULT_COLOR, senos: senos[0] && senos[0].value,
                 thKey: thicknesses[0] && thicknesses[0].key,
                 tapKey: tapholes[0] && tapholes[0].key };
      // 2026-08-31: arranca VACIO. Antes se sembraba con el color inicial y eso lo convertia en una
      // 'eleccion' que sobrevivia a los saltos del grouping: al pasar del mueble blanco al taupe se
      // restauraba colorPref='weiss', que el taupe tambien ofrece, y ganaba al color del mueble
      // nuevo. Vacio, pickCombo cae en DEFAULT_COLOR y cada mueble arranca en el suyo. En cuanto el
      // cliente pulsa un swatch se llena y manda (memoria bordeaux de 2026-08-25, intacta).
      st.colorPref = null;
      // 2026-08-26: memoria de color POR MODELO para las cards del slider. `st.color` es el resuelto
      // del modelo ACTIVO; usarlo para pintar todas las cards hacía que al activar un modelo
      // solo-blanco (Tayla) el resto del carrusel se repintara en blanco, perdiendo p.ej. el bordeaux
      // que el cliente había elegido para Meira. Aquí se recuerda el último color resuelto de CADA
      // modelo; lo escriben reconcile()/applyForced() (todos los caminos que resuelven color pasan
      // por ahí) y lo lee basinCardData(). Se persiste junto al resto en __blWb3Selection.
      st.colorByModel = {};
      st.overtop = OVERTOP[0] ? OVERTOP[0].handle : null;

      var elModes = root.querySelector('[data-wb3-modes]');
      var elPills = root.querySelector('[data-wb3-pills]'), elCards = root.querySelector('[data-wb3-cards]');
      var elRow1 = root.querySelector('[data-wb3-row1]'), elRow2 = root.querySelector('[data-wb3-row2]');
      var elWrap = root.querySelector('[data-wb3-panelwrap]'), elSel = root.querySelector('[data-wb3-selected]');
      var elResolved = root.querySelector('[data-wb3-resolved]'), elProg = root.querySelector('[data-wb3-prog]');
      var slider = elCards; var noneLabel = root.getAttribute('data-label-none') || 'Ohne Waschtisch';
      var MODE_LABELS = { none: noneLabel,
                          basin: root.getAttribute('data-label-with') || 'Mit Waschtisch',
                          top: root.getAttribute('data-label-top') || 'Mit Waschtischplatte',
                          overtop: root.getAttribute('data-label-overtop') || 'Mit Aufsatzwaschbecken' };
      var SHOW_PRICE = root.getAttribute('data-show-price') !== 'false';
      var sectionId = root.getAttribute('data-section-id') || '';
      var productId = root.getAttribute('data-product-id') || '';
      win.__blWb3Selection = win.__blWb3Selection || {};   // persiste la selección entre swaps AJAX del grouping (en memoria, como v2)
      // 2026-08-26: sello de GENERACIÓN por sección. El swap del grouping (HTMLUpdateUtility.
      // viewTransition del tema) mantiene la sección VIEJA y la nueva conviviendo en el DOM durante
      // la transición (medido: >770 ms), así que `root.isConnected` NO distingue a la instancia
      // superseded: sus timers diferidos (p.ej. el reintento de 350 ms de onVariantChanged) pasaban
      // esa guarda y machacaban win.__blWb3 con el estado del producto ANTERIOR — buildBundle lee
      // ese global y el add inyectaba el lavabo del otro producto (UI "Weiß", carrito taupe).
      // Cada bind incrementa la generación de SU sectionId (compartido entre productos de la misma
      // plantilla); escribir estado global o DOM compartido exige ser la generación vigente Y seguir
      // en el DOM. La instancia superseded queda inerte en cuanto la nueva se monta.
      win.__blWb3Gen = win.__blWb3Gen || {};
      var GEN = (win.__blWb3Gen[sectionId] || 0) + 1;
      win.__blWb3Gen[sectionId] = GEN;
      function stale() { return win.__blWb3Gen[sectionId] !== GEN || !root.isConnected; }

      // restaura la selección previa (mismo sectionId) tras un swap; cada campo solo si sigue disponible, si no → default (1ª opción)
      function restoreSelection() {
        var s = win.__blWb3Selection[sectionId]; if (!s) return;
        // BL-125: 'basin' solo si este mueble tiene lavabos encastrados (uno solo-sobre-encimera no los
        // tiene) y 'overtop' solo si tiene lavabos sobre encimera; si no, se queda en «ohne»
        if ((s.mode === 'basin' && models.length) || s.mode === 'none' || (s.mode === 'top' && tops.length) || (s.mode === 'overtop' && OVERTOP.length)) st.mode = s.mode;
        if (s.top && tops.some(function (t) { return t.handle === s.top; })) st.top = s.top;
        if (s.overtop && OVERTOP.some(function (o) { return o.handle === s.overtop; })) st.overtop = s.overtop;
        if (models.indexOf(s.model) >= 0) st.model = s.model;
        if (colors.some(function (c) { return c.value === s.color; })) st.color = s.color;
        // 2026-08-25: la preferencia se restaura SIN validar contra `colors`. Es intención del usuario,
        // no estado montable. OJO: la premisa "no puntúa y no estorba" solo es cierta desde 2026-08-26,
        // cuando pickCombo la filtra contra los swatches ofrecidos — antes puntuaba igualmente y el
        // salto por el grouping podía montar un color que este mueble no ofrece (UI "Weiß", carrito
        // taupe). Validarla AQUÍ seguiría siendo un error: la borraría en el primer salto y al volver
        // a un mueble que sí la ofrece ya no habría memoria.
        if (s.colorPref) st.colorPref = s.colorPref;
        // colorByModel no se valida valor a valor: es intención de pintado, y basinCardData ya degrada
        // al color del activo (y de ahí a cualquier imagen del modelo) si aquí no existe esa combinación.
        // 2026-08-31: pero SOLO viaja dentro del mismo color de mueble. Es una caché de lo RESUELTO
        // para el mueble anterior: al saltar del blanco al taupe, un 'Meira=weiss' heredado dejaba esa
        // card en blanco en un mueble taupe, justo lo contrario de la regla. Lo que el cliente ELIGIÓ
        // no se pierde: eso vive en colorPref, que sí cruza el salto.
        if (s.colorByModel && s.furnColor === FURN_COLOR) st.colorByModel = Object.assign({}, s.colorByModel);
        if (senos.some(function (x) { return x.value === s.senos; })) st.senos = s.senos;
        if (thicknesses.some(function (t) { return t.key === s.thKey; })) st.thKey = s.thKey;
        if (tapholes.some(function (t) { return t.key === s.tapKey; })) st.tapKey = s.tapKey;
        if (st.mode !== 'basin') st.model = null;   // coherencia: modelo solo vive en modo basin
      }
      // 2026-09-10 · salto al hermano de N senos. Persiste la intención en DOS sitios: la selección
      // por sección (lo que restoreSelection lee de siempre, con `senos` ya cambiado) y un sello
      // `__blWb3Bridge` que el init del hermano consume UNA vez para (a) fijar senos aunque un
      // resolve() tardío de esta instancia repinte la selección y (b) auto-elegir el 1er modelo
      // vendible si el elegido no existe allí (p.ej. Ardelia no tiene doble seno): el cliente pidió
      // «2 senos», no «sin lavabo». Sello con caducidad: un swap abortado no puede secuestrar el
      // siguiente salto del grouping. NO se toca `st`: si el swap falla, esta instancia sigue
      // coherente. El swap lo hace el grouping (misma Breite vía su matriz); sin él, navegación
      // completa a la variante de la talla activa.
      function bridgeTo(br, senosVal) {
        if (stale()) return;
        var size = readSize(), sv = size ? br.sizes[size] : null;
        win.__blWb3Selection[sectionId] = { mode: 'basin', top: st.top, overtop: st.overtop, model: st.model, color: st.color, colorPref: st.colorPref, colorByModel: Object.assign({}, st.colorByModel), furnColor: FURN_COLOR, senos: senosVal, thKey: st.thKey, tapKey: st.tapKey };
        win.__blWb3Bridge = { sectionId: sectionId, senos: senosVal, ts: Date.now() };
        root.dispatchEvent(new CustomEvent('bl:wb3:bridge', { bubbles: true, detail: { url: br.url, senos: senosVal, size: size } }));
        if (win.BLProductGrouping && typeof win.BLProductGrouping.navigate === 'function') { win.BLProductGrouping.navigate(br.url); return; }
        win.location.href = br.url + (sv && sv.id ? '?variant=' + sv.id : '');
      }
      // llegada por puente: consume el sello (una vez; solo si es reciente y de esta sección)
      function consumeBridge() {
        var b = win.__blWb3Bridge;
        if (!b || b.sectionId !== sectionId) return false;
        win.__blWb3Bridge = null;
        if (Date.now() - (b.ts || 0) > 15000) return false;
        if (!models.length) return false;   // BL-125: mueble sin lavabos encastrados, el puente no aplica
        if (senos.some(function (x) { return x.value === b.senos; })) st.senos = b.senos;
        st.mode = 'basin';
        if (!st.model || models.indexOf(st.model) < 0) st.model = firstSellableModel() || models[0] || null;
        return true;
      }
      // 2026-09-23 · llegada desde la BARRA DE COMBINACIONES de la PLP. La card enlaza con
      // ?variant=<Breite minima>&bl_wb=<modelo>&bl_th=<grosor>&bl_senos=<n>&bl_color=<handle>, o con
      // ?variant=&bl_mode=top&bl_top=<encimera> desde «Solo tapa» (la
      // combinacion mas barata que calculo snippets/BL-plp-combo.liquid) y la PDP tiene que abrir ya
      // en ella, con su precio. Se consume UNA vez por carga: los swaps del grouping re-ejecutan init
      // y esos ya traen su propia seleccion (restoreSelection). Los parametros se retiran de la URL
      // para que compartir o recargar no fuerce otra vez la combinacion. Devuelve los ejes a fijar en
      // reconcile(); un valor que este modelo no ofrezca se ignora y el motor elige como siempre.
      function consumeDeepLink() {
        if (win.__blWb3DeepLinkDone) return null;
        var q; try { q = new URLSearchParams(win.location.search); } catch (e) { return null; }
        var model = q.get('bl_wb'), mode = q.get('bl_mode');
        if (!model && mode !== 'top') return null;
        win.__blWb3DeepLinkDone = true;
        var th = q.get('bl_th'), sn = parseInt(q.get('bl_senos'), 10), col = q.get('bl_color'), top = q.get('bl_top');
        try {
          ['bl_wb', 'bl_th', 'bl_senos', 'bl_color', 'bl_mode', 'bl_top'].forEach(function (k) { q.delete(k); });
          var qs = q.toString();
          win.history.replaceState(win.history.state, '', win.location.pathname + (qs ? '?' + qs : '') + win.location.hash);
        } catch (e) { /* noop */ }
        // 2026-09-23 · colección «Solo tapa»: ?bl_mode=top&bl_top=<handle de la encimera>. Abre en «Mit
        // Waschtischplatte» con esa encimera; reconcileTop() (se llama justo después en el init) la
        // corrige si la Breite activa no la vende, igual que tras un swap del grouping.
        // 2026-09-25 · sin bl_top (muestra de color de la card) o con una encimera que este mueble no ofrece:
        // la del COLOR DEL MUEBLE, misma regla que la card de «Solo tapa»; si no la tiene, la de siempre (blanca).
        if (mode === 'top') {
          if (!tops.length) return null;
          st.mode = 'top'; st.model = null;
          if (top && tops.some(function (t) { return t.handle === top; })) st.top = top;
          else {
            var own = FURN_COLOR && tops.find(function (t) { return t.color && t.color.value === FURN_COLOR; });
            if (own) st.top = own.handle;
          }
          return null;
        }
        if (models.indexOf(model) < 0) return null;
        st.mode = 'basin'; st.model = model;
        var cs = combosFor(model), fixed = {};
        if (th && cs.some(function (c) { return c.thKey === th; })) { st.thKey = th; fixed.thKey = th; }
        if (sn && cs.some(function (c) { return c.senos === sn; })) { st.senos = sn; fixed.senos = sn; }
        if (col && colorOffered(col) && cs.some(function (c) { return c.color === col && (!fixed.thKey || c.thKey === fixed.thKey); })) {
          st.color = col; fixed.color = col; st.colorByModel[model] = col;
        }
        return fixed;
      }
      function currentTop() { return tops.find(function (t) { return t.handle === st.top; }) || tops[0] || null; }
      // 2026-07-31 (decisión Luis): la encimera se vende por talla del MUEBLE y no cubre todos los
      // anchos — hoy 60/70/80/100/120, mientras que 58 de los 90 muebles ofrecen además 90. Si la
      // talla activa no tiene variante de encimera, el modo tapa NO se puede seleccionar para esa
      // talla. Se evalúa por producto y no de forma global por si en el futuro unas tapas cubren
      // anchos que otras no. Mismo criterio de vendibilidad que comboSellable() en los lavabos.
      function topAt(tp, size) {
        var v = tp && size ? tp.variants[size] : null;
        return v && v.available !== false ? v : null;
      }
      function topsAt(size) { return tops.filter(function (t) { return topAt(t, size); }); }
      // saca al selector de un estado imposible tras cambiar la Breite: sin ninguna tapa vendible se
      // vuelve a 'ohne'; si solo cae la tapa elegida, salta a la primera disponible. Devuelve true si
      // tocó algo (el llamante ya re-renderiza).
      function reconcileTop() {
        var size = readSize(), ok = topsAt(size);
        if (st.mode === 'top' && !ok.length) {
          // BL-074: un mueble obligado no puede caer en «sin lavabo» → al primer lavabo vendible
          if (REQ) { st.mode = 'basin'; forceRequiredBasin(); return true; }
          st.mode = 'none'; st.model = null; return true;
        }
        if (ok.length && !topAt(currentTop(), size)) { st.top = ok[0].handle; return true; }
        return false;
      }
      // 2026-11-02 · BL-125: lavabo sobre encimera. Mismo patrón que las encimeras: la variante sale de
      // la medida del mueble (variants[size]) y uno sin variante vendible en esa medida no se elige.
      function currentOvertop() { return OVERTOP.find(function (o) { return o.handle === st.overtop; }) || OVERTOP[0] || null; }
      function overtopAt(o, size) {
        var v = o && size ? o.variants[size] : null;
        return v && v.available !== false ? v : null;
      }
      function overtopsAt(size) { return OVERTOP.filter(function (o) { return overtopAt(o, size); }); }
      function overtopUnsellable(o) { var size = readSize(); return !!size && !overtopAt(o, size); }
      // tras cambiar la medida: sin ninguno vendible se vuelve a «ohne»; si solo cae el elegido, al
      // primero que sí se vende. Devuelve true si tocó algo.
      function reconcileOvertop() {
        if (!OVERTOP.length) return false;
        var size = readSize(), ok = overtopsAt(size);
        if (st.mode === 'overtop' && size && !ok.length) {
          if (REQ && models.length) { forceRequiredBasin(); return true; }
          if (!REQ) { st.mode = 'none'; return true; }
          return false;
        }
        if (ok.length && !overtopAt(currentOvertop(), size)) { st.overtop = ok[0].handle; return true; }
        return false;
      }

      function selName(opt) {
        if (opt === 'color') { var c = colors.find(function (x) { return x.value === st.color; }); return c ? c.name : ''; }
        if (opt === 'senos') { var s = senos.find(function (x) { return x.value === st.senos; }); return s ? s.name : st.senos; }
        if (opt === 'thick') { var t = thicknesses.find(function (x) { return x.key === st.thKey; }); return t ? t.name : ''; }
        var p = tapholes.find(function (x) { return x.key === st.tapKey; }); return p ? p.name : '';
      }
      // --- motor de disponibilidad (reescrito 2026-07-30 v2) ----------------------------------
      // Un COMBO = una configuración que EXISTE en el catálogo del modelo: (color, senos) los aporta
      // cada producto-lavabo; (grosor, taladro) salen de sus juegos propios (variant_5th/6th).
      // Todo —gating y pre-marcado— se resuelve buscando sobre esta lista y NUNCA evaluando ejes por
      // separado contra el estado actual: si un eje quedaba obsoleto (p.ej. color weiss al saltar a
      // un modelo que solo existe en bordeaux) envenenaba a los demás, todas las opciones salían no
      // disponibles y la válvula "si todo se deshabilita, no deshabilites nada" las reactivaba TODAS.
      var COMBOS = {};
      function combosFor(model) {
        if (COMBOS[model]) return COMBOS[model];
        var out = [];
        wbs.forEach(function (w) {
          if (w.model !== model) return;
          (w.thicknesses || []).forEach(function (t) {
            (w.tapholes || []).forEach(function (p) {
              out.push({ color: w.color && w.color.value, senos: senosNum(w), thKey: t.key, tapKey: p.key, wb: w });
            });
          });
        });
        COMBOS[model] = out;
        return out;
      }
      function comboSellable(c, size) {
        if (!size) return true;
        var v = c.wb.variants[variantKey(size, c.thKey, c.tapKey)];
        return !!(v && v.available !== false);
      }
      function activeModel() { return st.model || models[0]; }
      // ¿el modelo tiene ALGO vendible en esta talla? si no, no se bloquea por talla (evita panel muerto)
      function modelSellsAt(model, size) {
        return !!size && combosFor(model).some(function (c) { return comboSellable(c, size); });
      }
      // 2026-08-24 · un modelo SIN variante vendible en la Breite activa (p.ej. agotado con
      // "sell when out of stock" apagado) NO es seleccionable: pill deshabilitada, card con el
      // slash de los chips y click ignorado — mismo criterio que topAt() para las encimeras.
      // Con talla desconocida no se marca nada (misma convención que comboSellable: sin talla,
      // todo cuenta como vendible).
      function modelUnsellable(model) {
        var size = readSize();
        return !!size && !modelSellsAt(model, size);
      }
      function firstSellableModel() {
        for (var i = 0; i < models.length; i++) { if (!modelUnsellable(models[i])) return models[i]; }
        return null;
      }
      // BL-074: modo basin con modelo elegido (el que hubiera, o el 1er vendible) y sus ejes resueltos.
      // Solo para muebles obligados que iban a quedarse sin lavabo (arranque, swap o tapa caída).
      function forceRequiredBasin() {
        st.mode = 'basin';
        if (!st.model || models.indexOf(st.model) < 0) st.model = firstSellableModel() || models[0] || null;
        if (st.model) { reconcile({}); applyForced(); }
        if (elWrap) elWrap.classList.toggle('is-open', !!st.model);
      }
      var OPTKEY = { color: 'color', senos: 'senos', thick: 'thKey', tap: 'tapKey' };
      // ¿este valor es ALCANZABLE? Se mira si existe algún combo del modelo con ese valor —
      // reajustando los demás ejes—, no si encaja con la selección actual. Así desaparece el bloqueo
      // mutuo (“el color pedía el faldón y el faldón pedía el color”).
      function avail(opt, value) {
        var model = activeModel(), size = readSize(), k = OPTKEY[opt];
        var cs = combosFor(model).filter(function (c) { return c[k] === value; });
        if (!cs.length) return false;                      // el modelo no lo ofrece → deshabilitado SIEMPRE
        if (!modelSellsAt(model, size)) return true;       // el modelo no vende nada en esta talla → no bloquear más
        return cs.some(function (c) { return comboSellable(c, size); });
      }
      // mejor combo que respeta `fixed` (el eje que el usuario acaba de pulsar) conservando lo máximo
      // posible del resto; prioridad color > senos > faldón > grifo
      // 2026-08-31: dos escalones de color. Pesos reescalados (16/8/4/2/1) para que el orden de
      // prioridad no cambie: 16 > 8+4+2+1 y 8 > 4+2+1, asi que el color sigue mandando sobre senos,
      // faldon y grifo, y entre combos que NO tienen el color pedido gana el BLANCO — la segunda
      // mitad de la regla ('si no lo tiene, el blanco') — en vez de decidirlo el orden de la lista.
      var PREF = { color: 16, colorWeiss: 8, senos: 4, thKey: 2, tapKey: 1 };
      function pickCombo(model, fixed, size) {
        var cs = combosFor(model).filter(function (c) {
          for (var k in fixed) { if (c[k] !== fixed[k]) return false; }
          return true;
        });
        if (!cs.length) return null;
        var sellable = cs.filter(function (c) { return comboSellable(c, size); });
        var pool = sellable.length ? sellable : cs;        // nada vendible → igualmente el más parecido
        var best = null, bestScore = -1;
        // 2026-08-25: el color se puntúa contra la PREFERENCIA del usuario (`colorPref`), no contra el
        // color resuelto. Así un modelo solo-blanco por el que se pasa de camino no borra el bordeaux:
        // al volver a un modelo que sí lo ofrece, gana otra vez. El resto de ejes siguen puntuando
        // contra el estado vivo (comportamiento intacto).
        // 2026-08-26: la preferencia SOLO puntúa si este mueble la ofrece en sus swatches (`colors`).
        // Sin este filtro, saltar por el grouping a un mueble que no ofrece ese color hacía que
        // pickCombo eligiera igualmente el lavabo en el color preferido (los combos traen TODOS los
        // colores del lavabo, no solo los ofertados): la UI pintaba "Weiß" y el carrito recibía
        // taupe. La preferencia se conserva intacta; solo deja de puntuar donde no es montable.
        var pref = st.colorPref;
        if (pref && !colors.some(function (c) { return c.value === pref; })) pref = null;
        // 2026-08-31: sin eleccion del usuario se puntua contra DEFAULT_COLOR (el color del mueble),
        // no contra st.color. st.color es el RESUELTO y se degrada solo: bastaba pasar por un modelo
        // que solo existe en blanco para que el arranque en taupe se perdiera y ya no volviera.
        var wantColor = pref || DEFAULT_COLOR;
        pool.forEach(function (c) {
          var s = (c.color === wantColor ? PREF.color : (c.color === 'weiss' ? PREF.colorWeiss : 0)) +
                  (c.senos === st.senos ? PREF.senos : 0) +
                  (c.thKey === st.thKey ? PREF.thKey : 0) + (c.tapKey === st.tapKey ? PREF.tapKey : 0);
          if (s > bestScore) { bestScore = s; best = c; }
        });
        return best;
      }
      // reconcilia la selección con el modelo activo. `fixed` = eje recién elegido: NUNCA se le
      // deshace el click al usuario, se reajustan los otros ejes a su alrededor.
      function reconcile(fixed) {
        var c = pickCombo(activeModel(), fixed || {}, readSize());
        if (!c) return false;
        var changed = st.color !== c.color || st.senos !== c.senos || st.thKey !== c.thKey || st.tapKey !== c.tapKey;
        st.color = c.color; st.senos = c.senos; st.thKey = c.thKey; st.tapKey = c.tapKey;
        if (st.model) st.colorByModel[st.model] = c.color;   // memoria por modelo (cards del slider)
        return changed;
      }
      // ejes ocultos por toggle → se fijan a FORCED, pero SOLO con lavabo elegido (fuera del modo
      // 'basin' no hay configuración de lavabo que forzar; es la condición pedida). Se intenta el
      // juego completo y, si el modelo activo no lo ofrece, se cede eje a eje: un combo inexistente
      // dejaría `variant` en null y rompería el ATC, y es preferible montar lo que el modelo sí hace
      // (mismo criterio que reconcile). Si no ofrece ninguno de los dos, se deja el estado intacto.
      // `keep` = el eje que el usuario acaba de pulsar (color/faldón): viaja en TODOS los intentos
      // para que el forzado no le deshaga el click — si su color no tiene el combo forzado, manda el
      // click y el eje oculto se queda con lo que ese color sí monta.
      function applyForced(keep) {
        if (st.mode !== 'basin' || !st.model) return false;
        var f = {};
        if (HIDE.senos && senos.some(function (s) { return s.value === FORCED.senos; })) f.senos = FORCED.senos;
        if (HIDE.tap && tapholes.some(function (t) { return t.key === FORCED.tapKey; })) f.tapKey = FORCED.tapKey;
        var ks = Object.keys(f);
        if (!ks.length) return false;
        var base = keep || {};
        var withKeep = function (extra) {
          var o = {};
          Object.keys(base).forEach(function (k) { o[k] = base[k]; });
          Object.keys(extra).forEach(function (k) { o[k] = extra[k]; });
          return o;
        };
        var tries = [withKeep(f)];
        if (ks.length > 1) ks.forEach(function (k) { var one = {}; one[k] = f[k]; tries.push(withKeep(one)); });
        var size = readSize(), c = null;
        for (var i = 0; i < tries.length && !c; i++) c = pickCombo(activeModel(), tries[i], size);
        if (!c) return false;
        var changed = st.color !== c.color || st.senos !== c.senos || st.thKey !== c.thKey || st.tapKey !== c.tapKey;
        st.color = c.color; st.senos = c.senos; st.thKey = c.thKey; st.tapKey = c.tapKey;
        if (st.model) st.colorByModel[st.model] = c.color;   // memoria por modelo (cards del slider)
        return changed;
      }

      // V4: fila de modos (la pill de encimera solo si hay tops)
      function renderModes() {
        if (!elModes) return;
        // la pill de tapa se deshabilita (no se oculta) cuando la talla activa no tiene encimera:
        // ocultarla haría saltar la fila al cambiar de Breite y el cliente no sabría que existe
        var noTopsHere = !topsAt(readSize()).length;
        var noOvertopHere = !overtopsAt(readSize()).length && !!readSize();
        // BL-074: sin «Sin lavabo» en un mueble obligado; con un solo modo la fila sobra entera
        // BL-125: «Mit Waschtisch» solo con lavabos encastrados; «Mit Aufsatzwaschbecken» con lavabos
        // sobre encimera. Orden: ohne · mit · Aufsatz · Platte (las de siempre no se mueven).
        var ms = REQ ? [] : ['none'];
        if (models.length) ms.push('basin');
        if (OVERTOP.length) ms.push('overtop');
        if (tops.length) ms.push('top');
        if (ms.length < 2) { elModes.innerHTML = ''; elModes.style.display = 'none'; return; }
        elModes.style.display = '';
        elModes.innerHTML = ms.map(function (m) {
          var dis = (m === 'top' && noTopsHere) || (m === 'overtop' && noOvertopHere);
          return '<button type="button" class="swatch-underline' + (m === st.mode ? ' active' : '') + '" data-wb3-mode="' + m + '" aria-pressed="' + (m === st.mode ? 'true' : 'false') + '"' + (dis ? ' disabled aria-disabled="true"' : '') + '>' + esc(MODE_LABELS[m]) + '</button>';
        }).join('');
      }
      // datos de la card de un modelo para la combinación activa (imagen + material)
      // 2026-08-21 · la foto se resuelve SIEMPRE dentro del juego del PROPIO lavabo. Antes, un combo
      // no mapeado caía directo a `w.image` (la destacada), y en Toren y Tayla la destacada NO es
      // ninguna de sus 4 fotos de combo — es una foto antigua distinta (verificado en el catálogo:
      // en Nivara/Ardelia/Meira sí coincide con su combo por defecto, por eso ahí no se notaba).
      // Efecto: al saltar de Ardelia (único faldón 6) a Toren, `reconcile()` movía el faldón 6→2 por
      // su cuenta y las cards de Toren y Tayla cambiaban de foto sin que el cliente hubiera tocado
      // faldón ni orificio. Con el degradado al combo POR DEFECTO del modelo (su 1er faldón, y con
      // orificio si su taladro tampoco está mapeado) la foto de un modelo solo cambia cuando cambia
      // algo de SU propio mapa: cambiar de modelo ya no repinta el resto del carrusel.
      function basinCardData(m) {
        // 2026-08-26: cada card se pinta con el último color RESUELTO para ESE modelo (colorByModel),
        // no con el del modelo activo: estando en Tayla (solo blanco), la card de Meira sigue en el
        // bordeaux que el cliente le eligió. Degradado: color del activo → cualquier imagen del modelo.
        // 2026-08-31: sin memoria para ese modelo (primera carga) el arranque ya no es el color global
        // sino el del mueble si ESE lavabo lo tiene, y blanco si no (defaultColorFor).
        var mc = st.colorByModel[m] || defaultColorFor(m);
        var w = findWb(wbs, m, mc, st.senos) ||
                findWb(wbs, m, 'weiss', st.senos) ||   // el color pedido no existe con estos senos -> blanco
                findWb(wbs, m, st.color, st.senos) ||
                wbs.find(function (x) { return x.model === m; });
        if (!w) return { img: '', mat: '' };
        var vi = w.variantImgs || {};
        var dthk = (w.thicknesses && w.thicknesses[0] && w.thicknesses[0].key) || st.thKey;
        // 2026-09-10: la foto de la card TAMBIÉN cambia con la talla del mueble (Breite). Clave nueva
        // de basin_variants_imgs = "talla|grosor|taladro" (p.ej. "120|2|con"); talla = mismo token que
        // las claves de `variants` (readSize: 1er número de la opción, sin "cm"). Se prueba primero
        // la cascada CON talla y se cae a la de 2 tokens de siempre, así un lavabo sin renders por
        // talla (o una talla sin render) sigue viéndose exactamente igual que hoy. Con talla NO se
        // degrada el taladro: antes que un render de la talla con el orificio equivocado, el genérico.
        var size = readSize();
        var img = size ? (vi[size + '|' + st.thKey + '|' + st.tapKey] || vi[size + '|' + dthk + '|' + st.tapKey]) : null;
        img = img || vi[st.thKey + '|' + st.tapKey] || vi[dthk + '|' + st.tapKey] || vi[dthk + '|con'] || w.image;
        return { img: img || '', mat: w.material || '' };
      }
      // 2026-08-25 · MATERIAL DE LA CARD (custom.card_material, multi_line_text). El dato real trae
      // un renglón por línea y cada uno abierto con "- " (verificado en catálogo: Nivara, Toren,
      // Ardelia, Meira, Tayla). Antes se pintaba como un único <p> escapado, así que el navegador
      // colapsaba los \n y los cuatro renglones salían pegados en un párrafo corrido. Ahora cada
      // renglón es un <li> propio y el guion lo pone el CSS (::before), no un bullet — por eso aquí
      // se DESPOJA el marcador de origen: si no, saldría "- -". Decisión Victor: la card muestra
      // solo el PRIMER renglón y el resto se despliega con la "v" del toggle.
      function matLines(mat) {
        return String(mat == null ? '' : mat).split(/\r?\n/)
          .map(function (l) { return l.replace(/^\s*[-–—•*]\s*/, '').trim(); })
          .filter(function (l) { return l; });
      }
      // ojo: `CHEVRON` (flecha DERECHA) ya existe más abajo para las navs del preview y `var` hoistea
      // a la misma función → esta necesita nombre propio o el toggle acaba pintando la flecha del preview.
      var MAT_CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      // ajuste del bloque (main-product.liquid): 'all' pinta los renglones a la vista y SIN toggle;
      // 'first' (defecto) deja solo el primero y el resto detrás de la "v".
      var MAT_ALL = root.getAttribute('data-material-display') === 'all';
      // 2026-08-25 (decisión Victor): el desplegado es UNO para todo el carrusel, no por card. Tocar
      // la "v" de cualquier lavabo abre o cierra los cinco a la vez, así el swiper nunca queda con
      // cards de dos alturas distintas. `matOpen` es la única fuente de verdad: la lee tanto el
      // pintado completo como el patch quirúrgico, así que un repintado no puede desincronizarlas.
      var matOpen = false;
      function matHtml(mat) {
        var ls = matLines(mat);
        if (!ls.length) return '';
        var rest = ls.slice(1).map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('');
        var toggle = rest && !MAT_ALL;
        var open = MAT_ALL || (toggle && matOpen);
        return '<div class="washbasin-selector__material wb3-mat' + (open ? ' is-open' : '') + '">' +
          '<ul class="wb3-mat__list"><li>' + esc(ls[0]) + '</li>' + rest + '</ul>' +
          (toggle ? '<button type="button" class="wb3-mat__toggle" data-wb3-mattoggle aria-expanded="' + (matOpen ? 'true' : 'false') + '">' +
            '<span data-wb3-mattoggle-text>' + esc(matOpen ? I18N.detailsHide : I18N.detailsShow) + '</span>' + MAT_CHEVRON + '</button>' : '') +
          '</div>';
      }
      // aplica el estado a UNA card. La card es role="button": el click en el toggle no debe
      // seleccionar el modelo (ver stopPropagation en el listener).
      function setMatOpen(box, open) {
        if (!box) return;
        box.classList.toggle('is-open', open);
        var btn = box.querySelector('[data-wb3-mattoggle]'); if (!btn) return;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var txt = btn.querySelector('[data-wb3-mattoggle-text]');
        if (txt) txt.textContent = open ? I18N.detailsHide : I18N.detailsShow;
      }
      // el toggle real: mueve el estado global y lo propaga a todas las cards montadas
      function setAllMatOpen(open) {
        matOpen = open;
        Array.prototype.forEach.call(elCards.querySelectorAll('.wb3-mat'), function (b) { setMatOpen(b, open); });
      }
      // 2026-10-10 (QA): las fotos de las cards iban todas lazy y, en un slider horizontal, el
      // navegador no pedia ni las visibles hasta tarde: llegaban despues que la galeria. Las dos
      // primeras (la visible y la que asoma) se piden enseguida a prioridad baja; el resto, lazy.
      function cardImgAttrs(i) { return i < 2 ? ' loading="eager" fetchpriority="low"' : ' loading="lazy"'; }
      function basinCardsHtml() {
        return models.map(function (m, i) {
          var d = basinCardData(m), img = d.img, mat = d.mat;
          var active = st.mode === 'basin' && m === st.model;
          var dis = modelUnsellable(m);
          // 2026-07-30 (decisión Victor): la card NUNCA lleva el nombre del modelo, tampoco en el
          // escaparate "ohne Waschtisch" (antes solo se ocultaba en modo basin). El nombre vive en las
          // pills y en el encabezado; la card se queda con foto + material.
          return '<div class="washbasin-selector__item' + (active ? ' is-active' : '') + (dis ? ' is-unavailable' : '') + '" data-wb3-model="' + esc(m) + '" role="button" tabindex="0" aria-label="' + esc(m) + '" aria-pressed="' + (active ? 'true' : 'false') + '" aria-disabled="' + (dis ? 'true' : 'false') + '">' +
            '<div class="washbasin-selector__label"><div class="washbasin-selector__image-wrapper">' +
            (img ? '<img class="washbasin-selector__img" src="' + esc(img) + '" alt="' + esc(m) + '"' + cardImgAttrs(i) + '>' : '') +
            '</div><div class="washbasin-selector__info">' +
            matHtml(mat) + '</div></div></div>';
        }).join('');
      }
      // 2026-08-21 · REPINTADO QUIRÚRGICO de las cards del slider. Reescribir `elCards.innerHTML`
      // devuelve el scroll a 0: al cambiar orificio / color / faldón / senos el lavabo elegido
      // seguía MARCADO pero desaparecía de la vista y el carrusel volvía a mostrar el primer
      // modelo (bug reportado en móvil). Aquí solo se actualizan imagen, material y estado activo
      // sobre los nodos que YA existen → el slider no se mueve. Devuelve false si el juego montado
      // no es el de `models` (p.ej. viniendo del modo tapa, que monta una card de encimera): en ese
      // caso el llamante repinta entero.
      function patchBasinCards() {
        var items = Array.prototype.slice.call(elCards.querySelectorAll('.washbasin-selector__item[data-wb3-model]'));
        if (items.length !== models.length) return false;
        for (var i = 0; i < items.length; i++) { if (items[i].getAttribute('data-wb3-model') !== models[i]) return false; }
        items.forEach(function (el, i) {
          var m = el.getAttribute('data-wb3-model'), d = basinCardData(m);
          var wrap = el.querySelector('.washbasin-selector__image-wrapper');
          var img = wrap && wrap.querySelector('.washbasin-selector__img');
          if (wrap) {
            if (d.img && !img) {
              img = doc.createElement('img'); img.className = 'washbasin-selector__img';
              img.setAttribute('loading', i < 2 ? 'eager' : 'lazy'); if (i < 2) img.setAttribute('fetchpriority', 'low');
              img.setAttribute('alt', m); wrap.appendChild(img);
            }
            if (img && !d.img) img.parentNode.removeChild(img);
            else if (img && img.getAttribute('src') !== d.img) img.setAttribute('src', d.img);
          }
          var info = el.querySelector('.washbasin-selector__info');
          // el material ya no es texto plano sino lista + toggle, así que el patch reescribe el
          // bloque entero cuando el dato cambia (y solo entonces: `__blMat` guarda el material
          // pintado). Se conserva si estaba desplegado para no cerrarle los detalles al cliente
          // por haber tocado color / faldón / orificio.
          if (info && info.__blMat !== d.mat) {
            var box = info.querySelector('.washbasin-selector__material');
            if (box) box.parentNode.removeChild(box);
            if (d.mat) info.insertAdjacentHTML('beforeend', matHtml(d.mat));   // nace ya con `matOpen`
            info.__blMat = d.mat;
          }
          var active = st.mode === 'basin' && m === st.model;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-pressed', active ? 'true' : 'false');
          var dis = modelUnsellable(m);   // la Breite pudo cambiar desde el último paint
          el.classList.toggle('is-unavailable', dis);
          el.setAttribute('aria-disabled', dis ? 'true' : 'false');
        });
        return true;
      }
      // red de seguridad tras un repintado COMPLETO: si la card activa quedó fuera de la ventana
      // visible del slider se trae a la vista SIN animación. Si ya se ve, no se toca el scroll
      // (regla 2026-08-21: el slider no debe moverse cuando el cambio no afecta al modelo elegido).
      function keepActiveCardInView() {
        if (st.mode !== 'basin' || !st.model) return;
        var card = elCards.querySelector('.washbasin-selector__item.is-active'); if (!card) return;
        var l = card.offsetLeft, r = l + card.offsetWidth;
        if (l >= slider.scrollLeft - 1 && r <= slider.scrollLeft + slider.clientWidth + 1) return;
        var max = Math.max(0, slider.scrollWidth - slider.clientWidth);
        slider.scrollLeft = Math.min(max, Math.max(0, l - (slider.clientWidth - card.offsetWidth) / 2));
      }
      // 2026-11-02 · BL-125: cards de lavabo sobre encimera = foto, modelo, precio y ficha técnica
      // (card_material, mismo desplegable que los encastrados). Sin panel de opciones: el lavabo no
      // tiene color, senos, faldón ni agujero que elegir. Activas solo en modo 'overtop'; en un mueble
      // sin lavabos encastrados también hacen de escaparate en «ohne» (pulsar una = elegirla).
      function overtopCardHtml(o, i, size) {
        var active = st.mode === 'overtop' && o.handle === st.overtop;
        var v = overtopAt(o, size), dis = !!size && !v;
        var price = SHOW_PRICE && v ? '<p class="washbasin-selector__price" data-wb3-otprice>' + esc(fmtCents(parseFloat(v.price) || 0)) + '</p>' : '';
        return '<div class="washbasin-selector__item' + (active ? ' is-active' : '') + (dis ? ' is-unavailable' : '') + '" data-wb3-overtop="' + esc(o.handle) + '" data-wb3-overtop-model="' + esc(o.model) + '" role="button" tabindex="0" aria-label="' + esc(o.model) + '" aria-pressed="' + (active ? 'true' : 'false') + '" aria-disabled="' + (dis ? 'true' : 'false') + '">' +
          '<div class="washbasin-selector__label"><div class="washbasin-selector__image-wrapper">' +
          (o.image ? '<img class="washbasin-selector__img" src="' + esc(o.image) + '" alt="' + esc(o.model) + '"' + cardImgAttrs(i) + '>' : '') +
          '</div><div class="washbasin-selector__info"><p class="wb3-card-name">' + esc(o.model) + '</p>' + price +
          matHtml(o.material) + '</div></div></div>';
      }
      // repinta las cards de lavabo sobre encimera; si ya están montadas (mismo juego y misma medida)
      // solo mueve el estado activo, para no devolver el slider al principio (regla 2026-08-21)
      function renderOvertopCards() {
        var size = readSize() || '';
        var sig = size + '|' + OVERTOP.map(function (o) { return o.handle; }).join(',');
        var items = Array.prototype.slice.call(elCards.querySelectorAll('.washbasin-selector__item[data-wb3-overtop]'));
        if (elCards.__blOtSig === sig && items.length === OVERTOP.length) {
          items.forEach(function (el) {
            var active = st.mode === 'overtop' && el.getAttribute('data-wb3-overtop') === st.overtop;
            el.classList.toggle('is-active', active);
            el.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          return;
        }
        elCards.innerHTML = OVERTOP.map(function (o, i) { return overtopCardHtml(o, i, size); }).join('');
        elCards.__blOtSig = sig;
      }
      function modelPillsHtml() {
        // la pill de un modelo agotado en esta Breite se deshabilita, no se oculta (la fila no debe
        // bailar al cambiar de talla — misma regla que los swatches de encimera)
        return models.map(function (m) { return '<button type="button" class="swatch-underline' + (m === st.model ? ' active' : '') + '" data-wb3-model="' + esc(m) + '" aria-pressed="' + (m === st.model ? 'true' : 'false') + '"' + (modelUnsellable(m) ? ' disabled' : '') + '>' + esc(m) + '</button>'; }).join('');
      }
      function renderModels() {
        syncTopPreview();
        if (st.mode === 'top') {
          // fila condicional = swatches de color de la encimera; swiper = 1 card de la encimera elegida
          // 2026-09-02: la fila también se conserva con UN solo color. Ocultarla en los top-vanity
          // de madera (solo blanco) pegaba el menú de modos contra el slider y escondía una opción
          // real del producto. Un único swatch sigue siendo información y estabiliza el espaciado.
          elPills.style.display = '';
          var tsize = readSize();
          elPills.innerHTML = tops.map(function (t) {
            var c = t.color || {};
            var sw = c.icon ? ('background-image:url(' + esc(c.icon) + ');background-size:cover;background-position:center')
                            : ('background-color:' + esc(c.hex || '#ddd'));
            // misma regla que la pill de modo, pero por tapa: la que no se vende en esta Breite queda
            // deshabilitada en vez de desaparecer (la fila de colores no debe bailar al cambiar talla)
            var dis = !topAt(t, tsize);
            return '<button type="button" class="bl-wb3__sw' + (t.handle === st.top ? ' is-active' : '') + '" data-wb3-topcolor="' + esc(t.handle) + '" title="' + esc(c.name || t.title) + '" aria-label="' + esc(c.name || t.title) + '" aria-pressed="' + (t.handle === st.top ? 'true' : 'false') + '"' + (dis ? ' disabled' : '') + ' style="' + sw + '"></button>';
          }).join('');
          elPills.__blSig = null;   // la fila lleva swatches de tapa, no pills de modelo (ver firma abajo)
          var tp = currentTop();
          elCards.innerHTML = tp ? ('<div class="washbasin-selector__item is-active" data-wb3-top="' + esc(tp.handle) + '">' +
            '<div class="washbasin-selector__label"><div class="washbasin-selector__image-wrapper">' +
            (tp.image ? '<img class="washbasin-selector__img" src="' + esc(tp.image) + '" alt="' + esc(tp.title) + '" loading="eager" fetchpriority="low">' : '') +
            // 2026-08-14: la card de tapa muestra el COLOR como nombre (no el title del producto) y
            // pierde el subtítulo para no duplicarlo; fallback al title si la tapa no resuelve color.
            '</div><div class="washbasin-selector__info"><p class="wb3-card-name">' + esc((tp.color && tp.color.name) || tp.title) + '</p>' +
            '</div></div></div>') : '';
          elCards.__blOtSig = null;
          return;
        }
        // BL-125: modo Aufsatz (o «ohne» en un mueble que solo lleva lavabos sobre encimera): sin fila
        // de pills —el modelo ya va en la card— y swiper con los lavabos sobre encimera
        if (st.mode === 'overtop' || (st.mode === 'none' && !models.length)) {
          elPills.style.display = 'none'; elPills.innerHTML = ''; elPills.__blSig = null;
          renderOvertopCards();
          return;
        }
        elCards.__blOtSig = null;
        // none/basin: swiper de lavabos SIEMPRE visible (escaparate en none, seleccionable en basin)
        if (st.mode === 'basin') {
          elPills.style.display = '';
          // la fila de pills también scrollea en móvil: se reescribe SOLO si su HTML cambia de
          // verdad (otro modelo activo). Antes cualquier re-render la devolvía al principio.
          var pillsHtml = modelPillsHtml();
          if (elPills.__blSig !== pillsHtml) { elPills.innerHTML = pillsHtml; elPills.__blSig = pillsHtml; }
        } else {
          elPills.style.display = 'none'; elPills.innerHTML = ''; elPills.__blSig = null;
        }
        // patch en sitio (conserva el scroll del slider); si el juego montado no es el de lavabos
        // —p.ej. se venía del modo tapa— se repinta entero y se recentra la card activa
        if (!patchBasinCards()) { elCards.innerHTML = basinCardsHtml(); keepActiveCardInView(); }
      }

      function group(opt, inner) { return '<div class="bl-wb3__group"><p class="bl-wb3__glabel" data-glabel="' + opt + '">' + esc(TITLES[opt]) + ': <b data-glabel-val>' + esc(selName(opt)) + '</b></p><div class="bl-wb3__opts">' + inner + '</div></div>'; }
      function chip(opt, value, key, name, icon, active, disabled, extra) {
        var ic = icon ? '<img src="' + esc(icon) + '" alt="' + esc(name) + '">' : '<span class="bl-wb3__chiptxt">' + esc(name) + '</span>';
        return '<button type="button" class="bl-wb3__chip' + (active ? ' is-active' : '') + '" data-wb3-opt="' + opt + '" data-value="' + esc(value) + '" data-key="' + esc(key) + '" title="' + esc(name) + '" aria-label="' + esc(name) + '" aria-pressed="' + (active ? 'true' : 'false') + '"' + (disabled ? ' disabled' : '') + (extra || '') + '>' + ic + '</button>';
      }
      // flags de deshabilitado por grupo. SIN válvula de escape: avail() ya garantiza ≥1 opción viva
      // por eje (los combos vendibles del modelo definen al menos un valor de cada eje; y si el modelo
      // no vende nada en esta talla, todo lo que ofrece queda habilitado).
      function disFlags(arr, opt, keyOf) {
        return arr.map(function (x) { return !avail(opt, keyOf(x)); });
      }
      function renderPanel() {
        var colorDis = disFlags(colors, 'color', function (c) { return c.value; });
        var senosDis = disFlags(senos, 'senos', function (s) { return s.value; });
        var thDis = disFlags(thicknesses, 'thick', function (t) { return t.key; });
        var tpDis = disFlags(tapholes, 'tap', function (t) { return t.key; });
        var colorHtml = colors.map(function (c, i) {
          // misma regla que el grouping del mueble: imagen-swatch del metaobject primero, luego color_code (hex)
          var sw = c.icon ? ('background-image:url(' + esc(c.icon) + ');background-size:cover;background-position:center')
                          : ('background-color:' + esc(c.hex || SWHEX[c.value] || '#ddd'));
          return '<button type="button" class="bl-wb3__sw' + (c.value === st.color ? ' is-active' : '') + '" data-wb3-opt="color" data-value="' + esc(c.value) + '" title="' + esc(c.name) + '" aria-label="' + esc(c.name) + '" aria-pressed="' + (c.value === st.color ? 'true' : 'false') + '"' + (colorDis[i] ? ' disabled' : '') + ' style="' + sw + '"></button>';
        }).join('');
        // 2026-09-10 · chip ajeno pero con puente en esta Breite: habilitado y marcado (data-wb3-bridge)
        var bsize = readSize();
        var senosHtml = senos.map(function (s, i) {
          var br = senosDis[i] && bridgeable(s.value, bsize);
          return chip('senos', s.value, s.value, s.name, s.icon, s.value === st.senos, senosDis[i] && !br, br ? ' data-wb3-bridge="1"' : '');
        }).join('');
        var thHtml = thicknesses.map(function (t, i) { return chip('thick', t.value, t.key, t.name, t.icon, t.key === st.thKey, thDis[i]); }).join('');
        var tpHtml = tapholes.map(function (t, i) { return chip('tap', t.value, t.key, t.name, t.icon, t.key === st.tapKey, tpDis[i]); }).join('');
        elRow1.innerHTML = group('color', colorHtml) + group('thick', thHtml);   // fila 1: Color · Faldón
        // fila 2: Senos · Grifo — cada grupo se omite si su toggle está activo. Con los dos activos la
        // fila queda vacía y NO deja hueco: .bl-wb3__optrow es `display: contents`, no aporta celda.
        elRow2.innerHTML = (HIDE.senos ? '' : group('senos', senosHtml)) + (HIDE.tap ? '' : group('tap', tpHtml));
      }

      // 2026-07-28: filtrado real de slides — la galería muestra SOLO las imágenes del combo activo
      // (claves color|grosor|senos del image map). Los slides/thumbs fuera del combo se retiran del DOM
      // (referencias en memoria, se reponen al cambiar de combo) y se actualizan los swipers (loop:false,
      // sin duplicados). Si el combo no está mapeado o sus media no existen como slides, NO se toca nada.
      function filterGallery(ids) {
        var want = ids.map(String);
        var wantKey = want.join(',');
        var changedAny = false;
        doc.querySelectorAll('media-gallery').forEach(function (g) {
          try {
            if (!g.__blSlides) {
              var sl = Array.prototype.slice.call(g.querySelectorAll('.product__media-item[data-media-id]'));
              if (!sl.length) return;
              var th = Array.prototype.slice.call(g.querySelectorAll('.product__thumbs-item[data-target]'));
              // parents capturados AQUI (todas las slides montadas): tras un filtrado previo la slide [0]
              // puede estar desmontada (parentNode null) y no serviria de referencia
              g.__blSlides = sl; g.__blSlidesParent = sl[0].parentNode;
              g.__blThumbs = th; g.__blThumbsParent = th.length ? th[0].parentNode : null;
            }
            // 2026-07-29: mismo filtro ya aplicado y el DOM sigue intacto → no tocar nada. Permite
            // REINTENTAR el filtrado inicial (media-gallery inicializa en diferido via Motion.inView y
            // puede resucitar slides) sin que cada pasada haga slideTo(0) y robe el scroll al usuario.
            if (g.__blFilterKey === wantKey && g.__blSlidesParent) {
              var live = Array.prototype.map.call(
                g.__blSlidesParent.querySelectorAll('.product__media-item[data-media-id]'),
                function (el) { return String(el.getAttribute('data-media-id')); }
              ).join(',');
              if (live === g.__blFilterApplied) return;
            }
            var apply = function (all, parent, attr) {
              if (!all.length || !parent) return null;
              var chosen = [];
              want.forEach(function (id) {
                all.forEach(function (el) { if (String(el.getAttribute(attr)) === id) chosen.push(el); });
              });
              if (!chosen.length) return null;   // combo sin slides renderizadas → conservar galería actual
              chosen.forEach(function (el) { el.classList.remove('bl-v3-gallery-supplemental'); el.removeAttribute('hidden'); });
              all.forEach(function (el) { if (el.parentNode === parent) parent.removeChild(el); });
              chosen.forEach(function (el) { parent.appendChild(el); });
              return chosen;
            };
            var chosen = apply(g.__blSlides, g.__blSlidesParent, 'data-media-id');
            if (!chosen) return;   // nada aplicable → no actualizar swipers ni firmas
            apply(g.__blThumbs, g.__blThumbsParent, 'data-target');
            g.__blFilterKey = wantKey;
            g.__blFilterApplied = chosen.map(function (el) { return String(el.getAttribute('data-media-id')); }).join(',');
            changedAny = true;
            // CLAVE (layout columns, sin swiper): setActiveMedia -> sortMediaItems reconstruye la lista
            // desde la cache interna elements.mediaItems; si no se sincroniza, RESUCITA las slides
            // filtradas y la galeria vuelve a mostrar todo
            if (g.elements && g.elements.mediaItems && g.elements.mediaItems.length) {
              g.elements.mediaItems = chosen.slice();
            }
            // 2026-07-30 (fix rejilla): en desktop SIN slider (data-enable-desktop-slider="false") la
            // galería es una REJILLA de 2 columnas por CSS (.product--columns .product__media-item
            // {width:50%}). Swiper corre con slidesPerView:1 y su update() escribe width inline en cada
            // slide → inline gana al CSS y la cuadrícula colapsa a 1 columna con N filas. Por eso el
            // swiper solo se toca cuando la galería está REALMENTE en modo slider; en rejilla se
            // limpian además los restos inline que hubiera dejado un update anterior (p.ej. si la
            // página se cargó en móvil y se ensanchó después).
            var isSlider = !(win.matchMedia && win.matchMedia('(min-width: 768px)').matches) ||
                           g.getAttribute('data-enable-desktop-slider') === 'true';
            if (isSlider) {
              var s = g.sliderInstance && g.sliderInstance.slider;
              if (s && !s.destroyed) { if (s.update) s.update(); if (s.slideTo) s.slideTo(0, 0, false); }
              var t = g.thumbsInstance && g.thumbsInstance.slider;
              if (t && !t.destroyed) { if (t.update) t.update(); if (t.slideTo) t.slideTo(0, 0, false); }
            } else {
              chosen.forEach(function (el) { el.style.width = ''; el.style.marginRight = ''; el.style.marginLeft = ''; });
            }
          } catch (e) { /* la galería nunca debe tumbar el selector */ }
        });
        return changedAny;
      }
      // núcleo común de swapHero/swapTopHero: filtra la galería a ids y deja el 1º como hero
      function showIds(ids) {
        if (!filterGallery(ids)) return;
        var id = ids[0];
        doc.querySelectorAll('media-gallery').forEach(function (g) {
          // media-gallery sin init() (móvil pre-inView) lanza en sortMediaItems (this.elements
          // undefined) → nunca debe abortar el init del selector; el reintento posterior lo cubre
          try { if (typeof g.setActiveMedia === 'function') g.setActiveMedia({ featured_media: { id: id } }); } catch (e) {}
        });
        syncStickyImage(id);            // el sticky-atc refleja la hero combinada del mueble
      }
      // 2026-07-29: fallback compartido — combo sin mapear en el image map → galería a las vistas
      // curadas por defecto (product_image_filter) en vez de quedarse con lo que hubiera (30 slides)
      function initialGalleryIds() {
        var g = doc.querySelector('media-gallery[data-bl-server-gallery-filter="true"]');
        var csv = (g && g.getAttribute('data-bl-initial-media-ids')) || '';
        return csv.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      }
      function firstGalleryIds(limit) {
        var g = doc.querySelector('media-gallery'); if (!g) return [];
        var slides = g.__blSlides || Array.prototype.slice.call(g.querySelectorAll('.product__media-item[data-media-id]'));
        return slides.slice(0, limit).map(function (el) { return String(el.getAttribute('data-media-id')); });
      }
      function fallbackCurated() {
        var ids = initialGalleryIds();
        if (!ids.length && data.curatedImages && data.curatedImages.length) ids = data.curatedImages;
        if (!(ids.length && filterGallery(ids))) {
          ids = firstGalleryIds(4);
          if (ids.length) filterGallery(ids);
        }
        return false;
      }
      // Clave del mapa furniture_basin_image_filter = "color|faldón|senos|agujero" (con / sin), la misma
      // forma que las fotos del lavabo ("2|con"). Un "sin" sin foto propia enseña la "con"; y mientras
      // quede alguna clave antigua de 3 valores ("weiss|2|1"), esa vale como "con".
      function basinIds() {
        var m = data.basinImages || {}, k = st.color + '|' + st.thKey + '|' + st.senos;
        return m[k + '|' + st.tapKey] || m[k + '|con'] || m[k];
      }
      function swapHero() {
        var ids = basinIds();
        if (!(ids && ids.length)) return fallbackCurated();
        showIds(ids);
        return true;
      }
      // 2026-07-31: gemelo de swapHero para el modo tapa. Clave del mapa furniture_top_image_filter =
      // handle del metaobjeto vanity_top_color ("bordeaux"), con el handle del producto encimera
      // ("arbeitsplatte-bordeaux") como clave alternativa para tapas sin color resuelto. Mientras el
      // mapa esté vacío (renders pendientes) cae a las curadas, que es el comportamiento previo.
      //
      // CONTRATO DE CLAVE (G3, cerrado 31-jul por Luis): UN solo token, el color. El ancho NO entra —
      // la identidad del propio producto mueble lo aporta, y que varios modelos con el mismo combo
      // compartan hero es intencional. Mismo criterio que furniture_basin_image_filter.
      // La resolución de abajo prueba además "<color>|<ancho>"; bajo el contrato de 1 token esa
      // variante nunca casa y se cae en "<color>" a la primera, así que es equivalente a indexar
      // directo. Se conserva como escotilla inerte por si algún mueble suelto necesitara arte por
      // ancho; el PIM debe seguir emitiendo 1 token.
      function topIds() {
        var tp = currentTop(); if (!tp) return null;
        var map = data.topImages || {}, size = readSize(), keys = [];
        if (tp.color && tp.color.value) {
          if (size) keys.push(tp.color.value + '|' + size);
          keys.push(tp.color.value);
        }
        if (size) keys.push(tp.handle + '|' + size);
        keys.push(tp.handle);
        for (var i = 0; i < keys.length; i++) { if (map[keys[i]] && map[keys[i]].length) return map[keys[i]]; }
        return null;
      }
      function swapTopHero() {
        var ids = topIds();
        if (!(ids && ids.length)) return fallbackCurated();
        showIds(ids);
        return true;
      }
      // 2026-11-02 · BL-125: fotos del mueble con el lavabo sobre encimera = el mapa de siempre
      // (furniture_basin_image_filter) con la clave "<color del lavabo>|aufsatz" (p.ej. "weiss|aufsatz");
      // el handle del lavabo vale como clave alternativa. Sin clave, a las curadas.
      function overtopIds() {
        var o = st.mode === 'overtop' ? currentOvertop() : null; if (!o) return null;
        var map = data.basinImages || {};
        var keys = [o.handle + '|aufsatz'];
        if (o.color && o.color.value) keys.unshift(o.color.value + '|aufsatz');
        for (var i = 0; i < keys.length; i++) { if (map[keys[i]] && map[keys[i]].length) return map[keys[i]]; }
        return null;
      }
      function swapOvertopHero() {
        var ids = overtopIds();
        if (!(ids && ids.length)) return fallbackCurated();
        showIds(ids);
        return true;
      }
      // fotos del modo activo (hero, pop-up de vista previa); none/basin = las del combo de lavabo, como siempre
      function modeIds() {
        if (st.mode === 'top') return topIds();
        if (st.mode === 'overtop') return overtopIds();
        return basinIds();
      }
      // 2026-07-29: alcance de la galería según estado (regla QA bordeaux): con lavabo ACTIVO (modo
      // basin) manda el combo (swapHero); sin opción v3 activa (ohne) la PDP muestra SOLO las vistas
      // curadas (product_image_filter), nunca las N slides que el server anexa para los swaps.
      // Re-aplicable: filterGallery ignora filtros ya aplicados.
      // 2026-07-31: el modo tapa deja de caer directo a las curadas — si la encimera activa está en
      // furniture_top_image_filter manda su combo; swapTopHero ya cae a curadas si no lo está, así
      // que la regla de arriba se conserva mientras el mapa esté vacío.
      function applyGalleryScope() {
        if (stale()) return;
        if (st.mode === 'basin' && st.model) { swapHero(); return; }
        if (st.mode === 'top' && st.top) { swapTopHero(); return; }
        if (st.mode === 'overtop' && st.overtop) { swapOvertopHero(); return; }
        fallbackCurated();
      }
      // re-aplica filtro de galería + disponibilidad tras un cambio de variante del MUEBLE: product-info
      // REEMPLAZA el nodo media-gallery por el HTML entrante (30 slides, sin filtrar) y luego dispara
      // 'variant:changed'. El swap (HTMLUpdateUtility.viewTransition) puede ser asíncrono → doble rAF
      // + reintento; filterGallery es idempotente y reconstruye sus cachés en el nodo nuevo.
      function onVariantChanged() {
        if (stale()) return;   // superseded por un bind más nuevo de esta sección, o ya fuera del DOM

        var apply = function () {
          if (stale()) return;   // el reintento de 350 ms sobrevive al swap: sin esto machacaba el estado
          if (st.model) { reconcile({}); applyForced(); }   // la nueva Breite puede no soportar la combinación actual
          reconcileTop();                // ídem para la encimera (p.ej. Breite 90 no tiene tapa)
          reconcileOvertop();            // BL-125: ídem para el lavabo sobre encimera
          renderModes();                // la pill de tapa se habilita/deshabilita según la Breite
          renderModels(); renderPanel(); applyGalleryScope(); resolve();
        };
        var raf = win.requestAnimationFrame || function (f) { win.setTimeout(f, 16); };
        raf(function () { raf(apply); });
        win.setTimeout(apply, 350);
      }
      // copia la URL de la slide del mueble (data-media-id) a la imagen principal del sticky-atc
      function syncStickyImage(id) {
        var slide = doc.querySelector('media-gallery [data-media-id="' + id + '"] img');
        var url = slide ? (slide.currentSrc || slide.getAttribute('src')) : null;
        if (!url) return;
        doc.querySelectorAll('.sticky-atc-bar__product-image img').forEach(function (img) { img.removeAttribute('srcset'); img.src = url; });
      }
      // URL de la hero del mueble para la combinación actual (fallback: 1ª slide de la galería).
      // 2026-07-31: mode-aware — en modo tapa la hero sale de topImages, no del combo de lavabo
      function currentHeroUrl() {
        var ids = modeIds();
        var img = (ids && ids.length && doc.querySelector('media-gallery [data-media-id="' + ids[0] + '"] img')) || doc.querySelector('media-gallery img');
        return img ? (img.currentSrc || img.getAttribute('src')) : null;
      }
      // 2026-09-17 · id de MEDIA de esa misma hero, para el carrito. Sale del DATO (los mapas
      // furniture_basin_image_filter / furniture_top_image_filter), no del DOM: vale aunque la galería
      // no haya hecho init (móvil pre-inView) o esté a medio swap. Mismas condiciones que
      // applyGalleryScope: sin lavabo ni encimera elegidos no hay combo y devuelve null (el carrito
      // se queda con la imagen de la variante, como siempre).
      function currentHeroMediaId() {
        var ids = null;
        if (st.mode === 'basin' && st.model) ids = basinIds();
        else if (st.mode === 'top' && st.top) ids = topIds();
        else if (st.mode === 'overtop' && st.overtop) ids = overtopIds();
        return ids && ids.length ? String(ids[0]) : null;
      }
      // pop-up de preview (solo móvil): espejo de la galería principal — mini-swiper scroll-snap con
      // las slides VIVAS de media-gallery (mismo orden/imágenes), margen 50px, X sutil arriba-dcha,
      // click fuera del swiper cierra. Se reconstruye en cada apertura (la galería cambia con color/faldón).
      // previewTarget = foto a la que van las flechas mientras dura la animación (null: manda el scroll).
      var elPrev, previewTrigger, previewTarget = null, previewSettle;
      // 2026-10-27: en iOS las flechas van SIN animación. Con `scroll-snap-type: x mandatory`, el
      // scrollTo suave de WebKit se corta o vuelve atrás cuando llega otro toque a medio camino, y
      // la gente insistía: tras el arreglo del 8-10 seguían con clic de rabia el 23–49 % de quienes
      // las usaban en iPhone cada día, frente al 3–25 % en Android (PostHog, 9→27-10). El salto
      // instantáneo cae exacto en la foto por el snap; Android y escritorio conservan la animación.
      // 2026-11-02: se llamaba `nav` y, al ser `var` en el mismo ámbito, PISABA la función nav(dir) de
      // las flechas de las cards: desde el 28-10 cada toque en ‹ › lanzaba «nav is not a function».
      var uaNav = win.navigator || {};
      var PREVIEW_SCROLL = (/iP(hone|ad|od)/.test(uaNav.userAgent || '') || (uaNav.platform === 'MacIntel' && uaNav.maxTouchPoints > 1)) ? 'auto' : 'smooth';
      // 2026-08-21: el botón "Vista previa" del panel vive DENTRO del desplegable, que solo se abre
      // con lavabo elegido → el modo "solo encimera" se quedaba sin preview. Tiene el suyo propio,
      // hermano del panel (mismo pop-up, misma regla de solo-móvil), y aquí se muestra/oculta.
      var elTopPrev = root.querySelector('[data-wb3-preview-top]');
      function syncTopPreview() {
        if (!elTopPrev) return;
        // BL-125: el modo Aufsatz tampoco abre el panel, así que usa este mismo botón
        if ((st.mode === 'top' && st.top) || (st.mode === 'overtop' && st.overtop)) elTopPrev.removeAttribute('hidden');
        else elTopPrev.setAttribute('hidden', '');
      }
      // slides actuales de la galería principal (dedupe por URL; puede haber galería mobile+desktop)
      function gallerySlides() {
        var out = [], seen = {};
        // 2026-08-26: `:not([hidden]):not(.bl-v3-gallery-supplemental)` — mismo criterio que el zoom.
        // El pop-up es un espejo de la galeria VIVA; si filterGallery no llego a podar (combo sin
        // slides renderizadas -> conserva la galeria actual) las suplementarias seguian en el DOM.
        doc.querySelectorAll('media-gallery [data-media-id]:not([hidden]):not(.bl-v3-gallery-supplemental)').forEach(function (s) {
          var img = s.querySelector('img'); if (!img) return;
          var u = img.currentSrc || img.getAttribute('src'); if (!u || seen[u]) return;
          seen[u] = 1; out.push({ id: s.getAttribute('data-media-id'), url: u });
        });
        return out;
      }
      function previewIndex(track) { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      // 2026-10-06: en la 1.ª foto no hay flecha «anterior» y en la última no hay «siguiente». Antes
      // seguían a la vista sin hacer nada y la gente las tocaba una y otra vez (44 % de quien las
      // usaba en móvil acababa con clic de rabia).
      function syncPreviewNav(idx) {
        if (!elPrev) return;
        var n = elPrev.querySelectorAll('.bl-wb3__preview-slide').length;
        elPrev.querySelectorAll('[data-wb3-prevnav]').forEach(function (b) {
          var to = idx + parseInt(b.getAttribute('data-wb3-prevnav'), 10);
          b.style.display = (n > 1 && to >= 0 && to <= n - 1) ? '' : 'none';
        });
      }
      function syncPreviewDots() {
        if (!elPrev) return;
        var track = elPrev.querySelector('[data-wb3-prevtrack]'); if (!track) return;
        var idx = previewIndex(track);
        elPrev.querySelectorAll('.bl-wb3__preview-dot').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        // con una flecha en curso manda su destino: la del extremo se va en el mismo toque
        syncPreviewNav(previewTarget == null ? idx : previewTarget);
      }
      var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      function buildPreview() {
        if (elPrev) return elPrev;
        elPrev = doc.createElement('div');
        elPrev.className = 'bl-wb3__preview'; elPrev.setAttribute('hidden', '');
        elPrev.setAttribute('role', 'dialog'); elPrev.setAttribute('aria-modal', 'true');
        elPrev.innerHTML = '<button type="button" class="bl-wb3__preview-close" data-wb3-previewclose aria-label="' + esc(I18N.close) + '">&times;</button>' +
          '<div class="bl-wb3__preview-swiper">' +
            '<div class="bl-wb3__preview-track" data-wb3-prevtrack></div>' +
            '<button type="button" class="bl-wb3__preview-nav bl-wb3__preview-nav--prev" data-wb3-prevnav="-1" aria-label="' + esc(I18N.previous) + '">' + CHEVRON + '</button>' +
            '<button type="button" class="bl-wb3__preview-nav bl-wb3__preview-nav--next" data-wb3-prevnav="1" aria-label="' + esc(I18N.next) + '">' + CHEVRON + '</button>' +
            '<div class="bl-wb3__preview-dots" data-wb3-prevdots></div>' +
          '</div>';
        elPrev.addEventListener('click', function (e) {
          var nv = e.target.closest('[data-wb3-prevnav]');
          if (nv) {
            var t = elPrev.querySelector('[data-wb3-prevtrack]');
            // 2026-10-06: por número de foto. El scrollBy relativo partía de la posición a medio
            // animar, así que dos toques seguidos avanzaban una foto (o ninguna); ahora cada toque
            // suma sobre el destino pendiente.
            var from = previewTarget == null ? previewIndex(t) : previewTarget;
            previewTarget = Math.max(0, Math.min(t.children.length - 1, from + parseInt(nv.getAttribute('data-wb3-prevnav'), 10)));
            t.scrollTo({ left: previewTarget * t.clientWidth, behavior: PREVIEW_SCROLL });
            syncPreviewNav(previewTarget);
            return;
          }
          if (e.target.closest('[data-wb3-previewclose]') || !e.target.closest('.bl-wb3__preview-swiper')) closePreview();
        });
        var prevTrack = elPrev.querySelector('[data-wb3-prevtrack]');
        prevTrack.addEventListener('scroll', function () {
          syncPreviewDots();
          // el destino pendiente caduca cuando el scroll se asienta
          win.clearTimeout(previewSettle);
          previewSettle = win.setTimeout(function () { previewTarget = null; syncPreviewDots(); }, 140);
        }, { passive: true });
        // si arrastran con el dedo a media animación, vuelve a mandar el scroll
        prevTrack.addEventListener('touchstart', function () { previewTarget = null; }, { passive: true });
        doc.body.appendChild(elPrev);
        return elPrev;
      }
      function openPreview(trigger) {
        var slides = gallerySlides();
        if (!slides.length) { var u = currentHeroUrl(); if (u) slides = [{ id: '', url: u }]; }
        if (!slides.length) return;
        var p = buildPreview(), track = p.querySelector('[data-wb3-prevtrack]'), dots = p.querySelector('[data-wb3-prevdots]');
        previewTrigger = trigger || doc.activeElement;
        track.innerHTML = slides.map(function (s) { return '<div class="bl-wb3__preview-slide"><img src="' + esc(s.url) + '" alt=""></div>'; }).join('');
        dots.innerHTML = slides.length > 1 ? slides.map(function () { return '<span class="bl-wb3__preview-dot"></span>'; }).join('') : '';
        p.removeAttribute('hidden');
        p.querySelector('[data-wb3-previewclose]').focus();
        // arranca en la hero de la combinación actual (si está mapeada); si no, en la 1ª slide.
        // 2026-08-21: mode-aware — en "solo encimera" la hero sale de topImages (antes se buscaba
        // siempre el combo de lavabo, que en modo tapa no existe, y el pop-up abría en la 1ª slide)
        var ids = modeIds() || [];
        var start = 0; slides.forEach(function (s, i) { if (ids.length && s.id === String(ids[0])) start = i; });
        win.clearTimeout(previewSettle); previewTarget = null; syncPreviewNav(start);
        (win.requestAnimationFrame || win.setTimeout)(function () { track.scrollLeft = start * track.clientWidth; syncPreviewDots(); });
      }
      function closePreview() {
        win.clearTimeout(previewSettle); previewTarget = null;
        if (elPrev) elPrev.setAttribute('hidden', '');
        if (previewTrigger && typeof previewTrigger.focus === 'function') previewTrigger.focus();
        previewTrigger = null;
      }
      function updateProgress() {
        if (!elProg) return; var max = slider.scrollWidth - slider.clientWidth;
        if (max <= 1) { elProg.style.width = '100%'; elProg.style.marginLeft = '0'; return; }
        var w = 42; elProg.style.width = w + '%'; elProg.style.marginLeft = (slider.scrollLeft / max * (100 - w)) + '%';
      }
      function resolve() {
        // 2026-08-26: ÚNICO escritor de win.__blWb3/__blWb3Selection — ver el sello de generación
        // arriba: isConnected solo no basta porque la sección vieja convive con la nueva durante el
        // viewTransition del swap. Misma guarda en los demás escritores de estado global/DOM
        // compartido (updateBundlePrice repinta price-<sectionId>, y el sectionId es EL MISMO entre
        // productos de la misma plantilla).
        if (stale()) return;
        var size = readSize();
        var wb = null, tp = null, ot = null, v = null;
        if (st.mode === 'basin' && st.model) {
          wb = findWb(wbs, st.model, st.color, st.senos);
          v = wb ? wb.variants[variantKey(size, st.thKey, st.tapKey)] : null;
        } else if (st.mode === 'top') {
          tp = currentTop();
          v = tp && size ? tp.variants[size] : null;   // encimera: variante por talla del mueble
        } else if (st.mode === 'overtop') {
          // BL-125: igual que la encimera, por la medida del mueble. Viaja en `variant` con un modo
          // distinto de 'top', así que los dos providers del /cart/add lo unen al mueble como lavabo
          // (_is_washbasin) sin cambios en el carrito. `washbasin` se queda en null a propósito: es la
          // forma de un lavabo encastrado (senos, faldón…) y el lavabo sobre encimera va en `overtop`.
          ot = currentOvertop();
          v = ot && size ? ot.variants[size] : null;
        }
        win.__blWb3 = { mode: st.mode, state: Object.assign({}, st), size: size, washbasin: wb, top: tp, overtop: ot, variant: v || null, heroMediaId: currentHeroMediaId() };
        win.__blWb3Selection[sectionId] = { mode: st.mode, top: st.top, overtop: st.overtop, model: st.model, color: st.color, colorPref: st.colorPref, colorByModel: Object.assign({}, st.colorByModel), furnColor: FURN_COLOR, senos: st.senos, thKey: st.thKey, tapKey: st.tapKey };
        root.dispatchEvent(new CustomEvent('bl:wb3:change', { bubbles: true, detail: win.__blWb3 }));
        publishSticky();
        updateBundlePrice();
        syncRequiredAtc(!!(v && v.id && v.available !== false));
        // indicador del header: solo el nombre de modelo/colección (sin color/senos) — decisión 2026-07-07
        if (elSel) {
          if (st.mode === 'basin' && st.model) elSel.textContent = st.model;
          else if (st.mode === 'top' && tp) elSel.textContent = MODE_LABELS.top;
          else if (st.mode === 'overtop' && ot) elSel.textContent = ot.model;
          else elSel.textContent = MODE_LABELS[st.mode] || noneLabel;
        }
        if (!elResolved) return;
        // SIN resumen detallado ni "+precio" (decisión 2026-07-07): el lavabo es parte del mueble y
        // el total va en el sticky. 2026-07-30: el aviso "Nicht verfügbar für …" se retiró (decisión
        // Victor) asumiendo que las combinaciones inexistentes eran inalcanzables. 2026-08-24: el
        // caso que quedó vivo es el modelo ELEGIDO que se queda sin variante vendible al cambiar la
        // Breite (elegirlo directamente ya lo impide el gating de modelUnsellable). SOLO en ese
        // estado se muestra el aviso — sin él, el panel abierto parece una selección válida mientras
        // el bundle la descarta en silencio; el resto del tiempo la línea sigue vacía.
        var unsellable = st.mode === 'basin' && !!st.model && !(v && v.available !== false);
        if (unsellable && size) {
          elResolved.textContent = (root.getAttribute('data-text-unavailable-size') || '').replace('__SIZE__', size);
          elResolved.classList.add('is-unavailable');
        } else {
          elResolved.textContent = '';
          elResolved.classList.remove('is-unavailable');
        }
      }

      // 2026-10-27 · BL-074: en un mueble obligado, sin lavabo/encimera válidos el botón de añadir
      // (el de la ficha y el de la barra fija) queda deshabilitado; el mueble nunca entra solo. Se
      // recuerda si el botón estaba activo ANTES ('on'/'off') para devolverle SOLO ese estado: un
      // mueble agotado (deshabilitado por el tema) no se reactiva al volver el lavabo. El tema
      // repinta el botón al cambiar de variante; resolve() corre después (onVariantChanged) y lo
      // vuelve a fijar.
      function syncRequiredAtc(ok) {
        if (!REQ) return;
        var sec = root.closest && root.closest('.shopify-section');
        var btns = sec ? Array.prototype.slice.call(sec.querySelectorAll('product-form button[type="submit"], form[action*="/cart/add"] button[name="add"]')) : [];
        btns = btns.concat(Array.prototype.slice.call(doc.querySelectorAll('.sticky-atc-bar__form [name="add"]')));
        btns.forEach(function (b) {
          if (!b || !b.setAttribute) return;
          if (!ok) {
            if (!b.hasAttribute('data-bl-wb3-required')) b.setAttribute('data-bl-wb3-required', (b.disabled && !b.hasAttribute('data-bl-wb3-waiting')) ? 'off' : 'on');
            b.disabled = true;
          } else if (b.hasAttribute('data-bl-wb3-required')) {
            var prev = b.getAttribute('data-bl-wb3-required');
            b.removeAttribute('data-bl-wb3-required');
            if (prev === 'on' && !b.hasAttribute('data-bl-wb3-waiting')) b.disabled = false;
          }
        });
      }

      function selectModel(id) {
        st.model = id || null;
        // pre-marcado 2026-07-30: el nuevo modelo puede no ofrecer la combinación actual → saltar al
        // combo válido más parecido; si cambia algo, las fotos de las cards cambian → re-render
        var remarked = st.model ? reconcile({}) : false;
        if (st.model && applyForced()) remarked = true;   // toggles de UI: re-fijar los ejes ocultos
        if (remarked) renderModels();
        // pills: todas clicables y con el MISMO tratamiento (gris inactivo / negro activo). El estado
        // de "no compatible" NO se pinta aquí: se resuelve solo al pulsarlas (decisión UX 2026-07-30).
        elPills.querySelectorAll('.swatch-underline').forEach(function (t) {
          t.classList.toggle('active', (t.getAttribute('data-wb3-model') || null) === st.model);
        });
        if (st.mode === 'basin') elPills.__blSig = modelPillsHtml();   // el toggle de arriba deja la firma al día: el próximo render no repinta la fila (ni le mueve el scroll)
        elCards.querySelectorAll('.washbasin-selector__item').forEach(function (c) {
          var active = c.getAttribute('data-wb3-model') === st.model;
          c.classList.toggle('is-active', active);
          if (c.hasAttribute('aria-pressed')) c.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        elWrap.classList.toggle('is-open', st.mode === 'basin' && !!st.model);
        if (st.model) { var card = elCards.querySelector('.washbasin-selector__item[data-wb3-model="' + (win.CSS && CSS.escape ? CSS.escape(st.model) : st.model) + '"]'); if (card) { var max = Math.max(0, slider.scrollWidth - slider.clientWidth); slider.scrollTo({ left: Math.min(max, Math.max(0, card.offsetLeft - (slider.clientWidth - card.offsetWidth) / 2)), behavior: 'smooth' }); } }
        renderPanel(); applyGalleryScope(); resolve();
      }
      // V4: cambio de modo. basin → auto-select del 1er modelo (spec Victor); none/top → sin modelo.
      function setMode(m) {
        if (st.mode === m) return;
        if (REQ && m === 'none') return;   // BL-074: la pill no se pinta; esto cierra cualquier otro camino
        if (m === 'basin' && !models.length) return;      // BL-125: sin lavabos encastrados no hay «mit»
        if (m === 'top' && !tops.length) return;          // BL-125: tapa incluida (o sin tapas) → no hay «Platte»
        if (m === 'overtop') {
          if (!OVERTOP.length) return;
          // al entrar, el elegido (o el primero) que se venda en esta medida; sin ninguno, la pill
          // ya viene deshabilitada
          var otOk = overtopsAt(readSize());
          if (readSize() && !otOk.length) return;
          if (otOk.length && !overtopAt(currentOvertop(), readSize())) st.overtop = otOk[0].handle;
        }
        st.mode = m;
        if (m !== 'basin') st.model = null;
        renderModes(); renderModels();
        elWrap.classList.toggle('is-open', false);
        if (m === 'basin') { selectModel(st.model || firstSellableModel() || models[0]); return; }   // auto-select del 1er modelo VENDIBLE en esta Breite (abre panel + resolve)
        renderPanel(); applyGalleryScope(); resolve();   // ohne/tapa → galería de vuelta a las curadas
        win.requestAnimationFrame ? win.requestAnimationFrame(updateProgress) : updateProgress();
      }
      // BL-125: elegir un lavabo sobre encimera (card o flecha). Desde «ohne» entra en el modo.
      function selectOvertop(handle) {
        var o = OVERTOP.find(function (x) { return x.handle === handle; });
        if (!o || overtopUnsellable(o)) return;
        var wasMode = st.mode;
        st.overtop = handle; st.mode = 'overtop'; st.model = null;
        if (wasMode !== 'overtop') renderModes();
        renderModels();
        elWrap.classList.toggle('is-open', false);
        var card = elCards.querySelector('.washbasin-selector__item.is-active');
        if (card) { var max = Math.max(0, slider.scrollWidth - slider.clientWidth); slider.scrollTo({ left: Math.min(max, Math.max(0, card.offsetLeft - (slider.clientWidth - card.offsetWidth) / 2)), behavior: 'smooth' }); }
        applyGalleryScope(); resolve();
      }
      // 2026-08-21: las flechas parten del modelo ELEGIDO, no de la card mas centrada en pantalla.
      // El scroll se recorta a [0, max], asi que en los extremos la card activa NO queda centrada
      // (con Nivara elegido el centro cae en Toren; con Tayla, en Meira) y el vecino se calculaba
      // desde la card equivocada: el recorrido saltaba Toren hacia adelante y Meira hacia atras.
      // La heuristica del centro se queda solo como fallback para los modos sin modelo (tapa/ohne).
      function nav(dir) {
        var cards = Array.from(elCards.querySelectorAll('.washbasin-selector__item')); if (!cards.length) return;
        // BL-125: cards de lavabo sobre encimera → la flecha elige el vecino vendible (como en «mit»)
        if (cards[0].hasAttribute('data-wb3-overtop')) {
          var oi = -1;
          if (st.mode === 'overtop') { for (var q = 0; q < cards.length; q++) { if (cards[q].getAttribute('data-wb3-overtop') === st.overtop) { oi = q; break; } } }
          var ostep = dir === 'next' ? 1 : -1, oj = oi < 0 ? (dir === 'next' ? 0 : -1) : oi + ostep;
          var oByH = function (h) { return OVERTOP.find(function (x) { return x.handle === h; }); };
          while (oj >= 0 && oj < cards.length && overtopUnsellable(oByH(cards[oj].getAttribute('data-wb3-overtop')))) oj += ostep;
          if (oj < 0 || oj >= cards.length) return;
          selectOvertop(cards[oj].getAttribute('data-wb3-overtop'));
          return;
        }
        var idx = -1;
        if (st.mode === 'basin' && st.model) {
          for (var j = 0; j < cards.length; j++) { if (cards[j].getAttribute('data-wb3-model') === st.model) { idx = j; break; } }
        }
        if (idx < 0) {
          var center = slider.scrollLeft + slider.clientWidth / 2, best = Infinity; idx = 0;
          cards.forEach(function (c, i) { var cc = c.offsetLeft + c.offsetWidth / 2; if (Math.abs(cc - center) < best) { best = Math.abs(cc - center); idx = i; } });
        }
        // 2026-08-25 (decisión Victor, #35): en «Ohne Waschtisch» la flecha TAMBIÉN compromete, igual
        // que hacía el v2 (`scrollSlider` siempre terminaba en `selectValue`). Antes solo scrolleaba,
        // así que quien navegaba con flechas nunca descubría que había que pulsar la card para elegir.
        // Mismo gesto que el click en card: modo → 'basin' + selección, y la card queda activa.
        // ⚠️ El modo 'top' NO entra: sus cards llevan `data-wb3-top` (no `data-wb3-model`), así que
        // caería un null en selectModel; ahí la flecha sigue siendo scroll (y solo hay 1 card).
        if (st.mode === 'basin' || st.mode === 'none') {
          // 2026-08-24: la flecha salta los modelos agotados en esta Breite; sin vecino vendible
          // en esa dirección no hace nada (mismo tope silencioso que en los extremos)
          var step = dir === 'next' ? 1 : -1, j2 = idx + step;
          while (j2 >= 0 && j2 < cards.length && modelUnsellable(cards[j2].getAttribute('data-wb3-model'))) j2 += step;
          if (j2 < 0 || j2 >= cards.length) return;
          // el id se lee ANTES de repintar: renderModels() reconstruye las cards y `cards[j2]` moriría
          var navModel = cards[j2].getAttribute('data-wb3-model');
          if (st.mode !== 'basin') { st.mode = 'basin'; renderModes(); renderModels(); }
          selectModel(navModel);
        } else {
          idx = dir === 'next' ? Math.min(cards.length - 1, idx + 1) : Math.max(0, idx - 1);
          slider.scrollTo({ left: Math.max(0, cards[idx].offsetLeft), behavior: 'smooth' });
        }
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-wb3-preview]')) { openPreview(e.target.closest('[data-wb3-preview]')); return; }
        var modeBtn = e.target.closest('[data-wb3-mode]');
        if (modeBtn) { setMode(modeBtn.getAttribute('data-wb3-mode')); return; }
        var topSw = e.target.closest('[data-wb3-topcolor]');
        // 2026-07-31: +applyGalleryScope — el swatch de encimera ya cambia la galería del mueble
        if (topSw) { st.top = topSw.getAttribute('data-wb3-topcolor'); renderModels(); applyGalleryScope(); resolve(); return; }
        var navb = e.target.closest('[data-wb3-prev],[data-wb3-next]');
        if (navb) { nav(navb.hasAttribute('data-wb3-next') ? 'next' : 'prev'); return; }
        var opt = e.target.closest('[data-wb3-opt]');
        if (opt) {
          if (opt.disabled) return;
          var o = opt.getAttribute('data-wb3-opt'), v = opt.getAttribute('data-value'), k = opt.getAttribute('data-key');
          var fixed = {};
          // 2026-08-25: ÚNICO punto que actualiza la preferencia de color. La reconciliación puede
          // degradar st.color al pasar por un modelo que no lo ofrece, pero la intención del usuario
          // se conserva aquí hasta que vuelva a tocar un swatch.
          if (o === 'color') { fixed.color = v; st.colorPref = v; }
          else if (o === 'senos') {
            fixed.senos = parseInt(v, 10);
            // 2026-09-10 · puente: ningún lavabo de ESTE mueble tiene ese nº de senos → si un hermano
            // lo ofrece en la Breite activa se salta a él (el chip solo llegó habilitado por eso)
            if (!localOffers(fixed.senos)) {
              var br = bridgeFor(fixed.senos, readSize());
              if (br) bridgeTo(br, fixed.senos);
              return;
            }
          }
          else if (o === 'thick') fixed.thKey = k;
          else if (o === 'tap') fixed.tapKey = k;
          Object.keys(fixed).forEach(function (kk) { st[kk] = fixed[kk]; });
          // 2026-07-30: el eje pulsado MANDA y los demás se reajustan al combo válido más parecido —
          // antes había que dar un 2º click (p.ej. color bordeaux dejaba el faldón en 2, inexistente)
          if (st.model) { reconcile(fixed); applyForced(fixed); }
          renderModels();   // color/senos/faldón/grifo cambian la foto de las cards
          renderPanel(); applyGalleryScope(); resolve();
          return;
        }
        // "v" del material: despliega/pliega los renglones 2..n SIN seleccionar el modelo
        var matBtn = e.target.closest('[data-wb3-mattoggle]');
        if (matBtn) {
          e.preventDefault(); e.stopPropagation();
          setAllMatOpen(!matOpen);
          return;   // las cards solo cambian de ALTO: ni el scroll ni la barra de progreso se tocan

        }
        var otCard = e.target.closest('[data-wb3-overtop]');   // BL-125
        if (otCard) { selectOvertop(otCard.getAttribute('data-wb3-overtop')); return; }
        var model = e.target.closest('[data-wb3-model]');
        if (model) {
          var mid = model.getAttribute('data-wb3-model') || null;
          // 2026-08-24: agotado en esta Breite → ni desde la card ni desde la pill (la pill ya viene
          // disabled del render; la card es un div y necesita el guard explícito)
          if (mid && modelUnsellable(mid)) return;
          if (st.mode !== 'basin' && mid) { st.mode = 'basin'; renderModes(); renderModels(); }   // escaparate → mit
          selectModel(mid);
        }
      });
      // 2026-07-30: en desktop, pasar el ratón por una opción PREVISUALIZA su nombre en el título del
      // grupo ("Schürze: 6 cm" mientras se sobrevuela el chip de 6). Al salir vuelve la selección real.
      if (!win.matchMedia || win.matchMedia('(hover: hover)').matches) {
        var glabel = function (opt, text) {
          var el = root.querySelector('[data-glabel="' + opt + '"] [data-glabel-val]');
          if (el) el.textContent = text;
        };
        root.addEventListener('mouseover', function (e) {
          var b = e.target.closest && e.target.closest('[data-wb3-opt]');
          if (!b) return;
          var o = b.getAttribute('data-wb3-opt');
          glabel(o, b.getAttribute('title') || selName(o));
        });
        root.addEventListener('mouseout', function (e) {
          var b = e.target.closest && e.target.closest('[data-wb3-opt]');
          if (!b) return;
          glabel(b.getAttribute('data-wb3-opt'), selName(b.getAttribute('data-wb3-opt')));
        });
      }
      root.addEventListener('keydown', function (e) {
        if (e.target.closest('[data-wb3-mattoggle]')) return;   // el toggle ya tiene su click nativo
        var card = e.target.closest('[data-wb3-model][role="button"], [data-wb3-overtop][role="button"]');
        if (!card || (e.key !== 'Enter' && e.key !== ' ')) return;
        e.preventDefault(); card.click();
      });
      doc.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && elPrev && !elPrev.hasAttribute('hidden')) closePreview();
      });
      slider.addEventListener('scroll', updateProgress, { passive: true });
      // re-render al cambiar la talla/variante del mueble (móvil y desktop)
      function onVariantChange() { if (stale()) return; renderPanel(); resolve(); }
      doc.addEventListener('change', function (e) { if (e.target.closest('variant-selects, .product-form__input')) onVariantChange(); });
      ['variant:change', 'variant:changed', 'variantChange'].forEach(function (ev) { doc.addEventListener(ev, onVariantChange); });
      // el tema re-renderiza el price-block al cambiar variante (async) → re-aplicar el precio combinado después
      if (win.FoxTheme && win.FoxTheme.pubsub && win.FoxTheme.pubsub.PUB_SUB_EVENTS && win.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange) {
        win.FoxTheme.pubsub.subscribe(win.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () { (win.requestAnimationFrame || win.setTimeout)(onVariantChange); });
      }

      // --- BUNDLE add-to-cart + sticky-atc (mismo contrato global que v2) ---
      // inyecta la variante de lavabo resuelta en /cart/add (mueble + lavabo, un solo add)
      function buildBundle(config) {
        if (stale()) return null;   // superseded o fuera del DOM → no inyectar nada (cae al provider vigente)
        var v = win.__blWb3 && win.__blWb3.variant;
        if (!v || !v.id || v.available === false) return null;   // sin addon válido → add normal (solo mueble)
        var isTop = win.__blWb3 && win.__blWb3.mode === 'top';
        var body = config && config.body, mainId, qty = 1, sections = '', sectionsUrl = '', mainProps = {};
        if (body instanceof FormData) {
          mainId = body.get('id'); qty = parseInt(body.get('quantity') || 1, 10) || 1;
          sections = body.get('sections') || ''; sectionsUrl = body.get('sections_url') || win.location.pathname;
          body.forEach(function (val, key) { if (key.indexOf('properties[') === 0) { var mm = key.match(/properties\[(.*?)\]/); if (mm) mainProps[mm[1]] = val; } });
        } else if (typeof body === 'string') {
          try { var b = JSON.parse(body); mainId = b.id || (b.items && b.items[0] && b.items[0].id); qty = parseInt(b.quantity || (b.items && b.items[0] && b.items[0].quantity) || 1, 10) || 1; sections = b.sections || ''; sectionsUrl = b.sections_url || win.location.pathname; mainProps = Object.assign({}, b.properties || (b.items && b.items[0] && b.items[0].properties) || {}); } catch (e) { return null; }
        } else { return null; }
        if (!mainId) return null;
        var bid = 'wb3_' + String(mainId) + '_' + String(v.id);
        mainProps._msw_bundle_id = bid; mainProps._linkedTo = String(v.id);
        // 2026-09-17: la miniatura del MUEBLE en el carrito es la foto del mueble CON el lavabo/encimera
        // elegidos (la hero que el cliente estaba viendo), no la imagen fija de la variante. Viaja el
        // id de media, no una URL: el carrito lo resuelve contra item.product.media, así que solo
        // puede salir una foto de ese mismo producto. Oculta en carrito y checkout por el «_».
        var heroMedia = win.__blWb3 && win.__blWb3.heroMediaId;
        if (heroMedia) mainProps._bl_hero_media = String(heroMedia);
        var addonProps = { _msw_bundle_id: bid, _linkedTo: String(mainId) };
        if (isTop) addonProps._is_vanity_top = 'true'; else addonProps._is_washbasin = 'true';
        // orden en carrito (Shopify lista de mas reciente a mas antiguo): el lavabo va PRIMERO en el
        // array para que el MUEBLE encabece el conjunto — mismo criterio que el provider compuesto
        return { items: [
          { id: parseInt(v.id, 10), quantity: qty, properties: addonProps },
          { id: parseInt(mainId, 10), quantity: qty, properties: mainProps }
        ], sections: sections, sectionsUrl: sectionsUrl };
      }
      (function installCart() {
        if (!win.__blCartAddonInterceptor) win.__blCartAddonInterceptor = { installed: false, originalFetch: win.fetch.bind(win), providers: new Map() };
        var reg = win.__blCartAddonInterceptor;
        if (!reg.installed) {
          reg.installed = true;
          win.fetch = function (url, config) {
            var u = typeof url === 'string' ? url : (url && url.url) || '';
            if (u.indexOf('/cart/add') < 0 || !config) return reg.originalFetch.call(this, url, config);
            var provs = Array.from(reg.providers.values()).sort(function (a, b) { return (b.priority || 0) - (a.priority || 0); });
            for (var i = 0; i < provs.length; i++) {
              // 2026-08-25 (hardening): un throw aqui saldria SINCRONO por window.fetch, y los
              // fetch().then().catch() del tema no capturan un throw sincrono → el boton se
              // quedaria en is-loading para siempre. Un provider roto degrada a "sin bundle".
              var pl = null;
              try { pl = provs[i] && provs[i].getBundlePayload && provs[i].getBundlePayload(config); }
              catch (e) { pl = null; }
              if (!pl || !Array.isArray(pl.items) || !pl.items.length) continue;
              var nc = Object.assign({}, config);
              nc.headers = Object.assign({}, config.headers || {}, { 'Content-Type': 'application/json', 'Accept': 'application/json' });
              nc.body = JSON.stringify({ items: pl.items, sections: pl.sections || '', sections_url: pl.sectionsUrl || win.location.pathname });
              return reg.originalFetch.call(this, url, nc);
            }
            return reg.originalFetch.call(this, url, config);
          };
        }
        reg.providers.set('wb3:' + (productId || 'main'), { priority: 20, getBundlePayload: buildBundle });
        // BL-074: mueble obligado → sus variantes no pueden viajar sin un lavabo/encimera suyos
        if (REQ) {
          installRequiredGuard(reg);
          var furn = {}, okv = {};
          (data.furnitureVariantIds || []).forEach(function (id) { furn[String(id)] = 1; });
          wbs.concat(tops, OVERTOP).forEach(function (w) {
            Object.keys((w && w.variants) || {}).forEach(function (k) { var vv = w.variants[k]; if (vv && vv.id) okv[String(vv.id)] = 1; });
          });
          win.__blWb3Required[productId || 'main'] = { furn: furn, ok: okv, msg: root.getAttribute('data-text-basin-required') || '' };
        }
        // 2026-08-28: carrera del tap temprano (P0 reproducido en movil): el interceptor se instala
        // al parsear pero ESTE registro llega al final del init — entre ambos, un tap añadia SOLO el
        // mueble, en silencio. El snippet bloquea el boton ATC en el parse del HTML y aqui, con el
        // provider ya operativo, se destrapa. El snippet lleva ademas timeout de seguridad de 5s.
        try { var rcbs = win.__blWb3ReadyCbs || []; while (rcbs.length) { var rcb = rcbs.shift(); try { rcb(); } catch (e0) {} } } catch (e1) {}
      })();

      // precio combinado (mueble base + lavabo) en price-block + sticky + botón ATC; reutiliza los globales del tema
      // 2026-08-24: devuelve tambien compare_at — con bundle activo el CSS oculta el .f-price nativo
      // y sin cablearlo el tachado de oferta del mueble desaparecia justo en el paso de mayor valor
      function muebleBase() {
        var selEl = (doc.querySelector('product-info') || doc).querySelector('[data-selected-variant]');
        if (selEl) {
          try {
            var sv = JSON.parse(selEl.textContent || '{}');
            return { price: parseInt(sv.price || 0, 10) || 0, compareAt: parseInt(sv.compare_at_price || 0, 10) || 0 };
          } catch (e) {}
        }
        return { price: 0, compareAt: 0 };
      }
      function injectButtonPrice(text) {
        var btns = [], b1 = doc.getElementById('ProductSubmitButton-' + sectionId);
        if (b1) btns.push(b1);
        doc.querySelectorAll('.main-product-form .product-form__submit, #shopify-section-sticky-atc-bar .product-form__submit').forEach(function (b) { if (btns.indexOf(b) < 0) btns.push(b); });
        btns.forEach(function (btn) {
          var span = btn.querySelector('.btn__text'); if (!span) return;
          var wrap = btn.querySelector('[data-btn-price-wrapper]');
          if (!wrap) {
            wrap = doc.createElement('span'); wrap.setAttribute('data-btn-price-wrapper', ''); wrap.className = 'btn__price-arrow-wrapper';
            wrap.innerHTML = '<span class="btn__price-separator">|</span><span data-btn-price-display></span><svg class="btn__price-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
            span.parentNode.insertBefore(wrap, span.nextSibling);
          }
          var disp = wrap.querySelector('[data-btn-price-display]'); if (disp) disp.textContent = text;
        });
      }
      // total de addons en céntimos: lavabo/encimera + grifos (carril v3) + espejos togglados (carril 2)
      function addonTotalCents() {
        var total = 0;
        var v = win.__blWb3 && win.__blWb3.variant;
        if (v && v.id && v.available !== false) total += parseFloat(v.price) || 0;
        var a3 = win.__blAddonsV3 || {};
        Object.keys(a3).forEach(function (k) {
          var s = a3[k];
          // s.qty = stepper del carril de grifos (1, o 2 por defecto con lavabo de dos senos)
          if (s && s.on && s.variant && s.variant.id && s.variant.available !== false) total += (parseFloat(s.variant.price) || 0) * (parseInt(s.qty, 10) || 1);
        });
        // espejos del carril v3 (2026-09-01): mismo contrato que los grifos — variante resuelta
        // a la talla del mueble y cantidad del stepper de la fila
        var a2m = win.__blAddonsSecond || {};
        Object.keys(a2m).forEach(function (k) {
          var s = a2m[k];
          if (s && s.on && s.variant && s.variant.id && s.variant.available !== false) total += (parseFloat(s.variant.price) || 0) * (parseInt(s.qty, 10) || 1);
        });
        doc.querySelectorAll('[data-product-addons] .product-addons__toggle:checked').forEach(function (t) {
          if (t.closest('[data-bl-addons2]')) return;   // espejos v3 ya sumados arriba via __blAddonsSecond
          var item = t.closest('.product-addons__item');
          var p = item && parseInt(item.getAttribute('data-addon-price'), 10);
          if (p) total += p;
        });
        return total;
      }
      // El total (mueble + lavabo/encimera + grifo + espejo) se muestra SOLO en el botón sticky
      // "In den Warenkorb | XXX €" (decisión 2026-07-07). No hay línea de total bajo el selector.
      function updateBundlePrice() {
        if (stale()) return;   // superseded por un bind más nuevo de esta sección, o ya fuera del DOM
        var addon = addonTotalCents();   // céntimos: lavabo/encimera + grifo + espejos
        var mb = muebleBase(), base = mb.price;
        var BPS = win.BLBundlePriceState; if (!BPS || typeof BPS.setOwnerState !== 'function') return;
        if (addon > 0 && base > 0 && typeof BPS.buildPriceState === 'function') {
          var state = BPS.buildPriceState(base, addon, { baseCompareAtPrice: mb.compareAt });
          if (state) {
            if (typeof BPS.ensureCSS === 'function') BPS.ensureCSS();
            var pb = doc.getElementById('price-' + sectionId) || (doc.querySelector('product-info') || doc).querySelector('[id^="price-"]');
            if (pb && BPS.applyPriceNode) BPS.applyPriceNode(pb, state, { lock: false });
            doc.querySelectorAll('sticky-atc-bar-minimalist .sticky-atc-bar__product-info, sticky-atc-bar .sticky-atc-bar__product-info').forEach(function (t) { if (t.querySelector('.f-price') && BPS.applyPriceNode) BPS.applyPriceNode(t, state, { lock: false }); });
            BPS.setOwnerState('washbasin-v2', true, { buttonReady: true });
            if (win.BLAtcPriceSync && win.BLAtcPriceSync.applyBundlePrice) win.BLAtcPriceSync.applyBundlePrice('washbasin-v2', state.displayPrice);
            injectButtonPrice(state.displayPrice);
            return;
          }
        }
        BPS.setOwnerState('washbasin-v2', false);
        if (win.BLAtcPriceSync && win.BLAtcPriceSync.clearBundlePrice) win.BLAtcPriceSync.clearBundlePrice('washbasin-v2');
      }

      // miniatura + nombre de los addons togglados: grifos (carril v3, __blAddonsV3) + espejos (carril 2)
      // 2026-09-02: `images` lleva TODAS las fotos (grifo Y espejo); `image` queda como la primera
      // para los consumidores del contrato viejo. El sticky pinta una miniatura por entrada.
      function addonStickyInfo() {
        var names = [], images = [];
        var a3 = win.__blAddonsV3 || {};
        Object.keys(a3).forEach(function (k) {
          var s = a3[k];
          if (!s || !s.on || !s.variant || !s.variant.id || s.variant.available === false) return;
          var p = s.product || {};
          var nm = p.pdpTitle || p.title || '';   // solo nombre de colección/modelo, SIN color (2026-07-07)
          var n = parseInt(s.qty, 10) || 1;       // stepper del carril de grifos
          if (nm) names.push(n > 1 ? (n + ' × ' + nm) : nm);
          if (p.image) images.push(p.image);
        });
        // espejos del carril v3 (2026-09-01): solo nombre de familia (Inari/Sil), sin talla ni
        // features — mismo criterio que los grifos, que van sin color (2026-07-07)
        var a2m = win.__blAddonsSecond || {};
        Object.keys(a2m).forEach(function (k) {
          var s = a2m[k];
          if (!s || !s.on || !s.variant || !s.variant.id || s.variant.available === false) return;
          var p = s.product || {};
          var nm = p.groupTitle || p.title || '';
          var n = parseInt(s.qty, 10) || 1;
          if (nm) names.push(n > 1 ? (n + ' × ' + nm) : nm);
          // s.image = foto de la TALLA elegida (variant.image) si existe; si no, la del producto
          var im = s.image || p.image;
          if (im) images.push(im);
        });
        doc.querySelectorAll('[data-product-addons] .product-addons__toggle:checked').forEach(function (t) {
          if (t.closest('[data-bl-addons3]')) return;   // grifos ya cubiertos vía __blAddonsV3
          if (t.closest('[data-bl-addons2]')) return;   // espejos v3 ya cubiertos vía __blAddonsSecond
          var item = t.closest('.product-addons__item'); if (!item) return;
          var nm = (item.getAttribute('data-addon-title') || '').trim();
          if (nm) names.push(nm);
          var im = item.getAttribute('data-addon-image') || '';
          if (im) images.push(im);
        });
        return { names: names, image: images[0] || '', images: images };
      }

      // actualiza la selección de lavabo en el sticky-atc (evento que ya escucha sticky-atc-bar-minimalist)
      function publishSticky() {
        if (stale()) return;   // superseded por un bind más nuevo de esta sección, o ya fuera del DOM
        var wb = win.__blWb3 && win.__blWb3.washbasin;
        var tp = win.__blWb3 && win.__blWb3.top;
        // 2026-08-24: el sticky solo anuncia lo que VIAJA al carrito — sin variante vendible
        // (agotado / combo inexistente en esta Breite) el bundle lo descarta, y anunciarlo hacía
        // creer al cliente que compraba el conjunto cuando solo se añadía el mueble
        var v = win.__blWb3 && win.__blWb3.variant;
        var sellable = !!(v && v.available !== false);
        var ot = win.__blWb3 && win.__blWb3.overtop;   // BL-125
        var has = sellable && ((st.mode === 'basin' && !!(st.model && wb)) || (st.mode === 'top' && !!tp) || (st.mode === 'overtop' && !!ot));
        var name = '';   // solo nombre de colección/modelo, SIN color/senos (2026-07-07)
        if (st.mode === 'basin' && wb) name = st.model;
        else if (st.mode === 'top' && tp) name = tp.title;
        else if (st.mode === 'overtop' && ot) name = ot.model;
        var ad = addonStickyInfo();
        var detail = { productId: productId, hasBasin: has,
          hasAddons: ad.names.length > 0,
          addonName: ad.names.join(' + '),
          addonNames: ad.names,
          addonImage: ad.image,
          addonImages: ad.images,
          basinName: name,
          basinImage: (st.mode === 'top' ? (tp && tp.image) : st.mode === 'overtop' ? (ot && ot.image) : (wb && wb.image)) || '' };
        win.__blWashbasinV2StickyState = win.__blWashbasinV2StickyState || {};
        win.__blWashbasinV2StickyState[String(productId || 'default')] = detail;
        doc.dispatchEvent(new CustomEvent('bl:washbasin-v2:sticky-update', { bubbles: true, detail: detail }));
      }

      // instancia expuesta: BL-product-addons (espejos) delega aquí el precio global
      // (mismo contrato que el selector v2: getCompanionWashbasin → scheduleGlobalPriceUpdate).
      // También republica el sticky: los espejos pueden cambiar sin disparar 'change' (p.ej. la
      // restauración programática tras un swap del grouping marca el toggle con .checked=true).
      root.__blWbInstance = { scheduleGlobalPriceUpdate: function () {
        (win.requestAnimationFrame || win.setTimeout)(function () { updateBundlePrice(); publishSticky(); });
      } };
      // recalcular total + miniaturas sticky al cambiar grifo (carril v3) o espejos (toggles del carril 2)
      doc.addEventListener('bl:addons3:change', function () { updateBundlePrice(); publishSticky(); });
      doc.addEventListener('bl:addons2:change', function () { updateBundlePrice(); publishSticky(); });   // espejos v3
      doc.addEventListener('variant:changed', onVariantChanged);   // Breite del mueble → re-filtrar galería + degradar opciones no soportadas
      doc.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.product-addons__toggle')) { updateBundlePrice(); publishSticky(); } });

      restoreSelection();                       // recupera la selección previa tras un swap del grouping
      consumeBridge();                          // 2026-09-10: llegada por puente de senos (ver bridgeTo)
      var deepFixed = consumeDeepLink();        // 2026-09-23: llegada desde la barra de combinaciones de la PLP
      // BL-074: mueble obligado → nunca arranca en «sin lavabo» (ni en frío ni tras un swap que venía
      // de un hermano en «ohne»); el bloque de abajo reconcilia los ejes del modelo elegido
      // BL-125: obligado y sin lavabos encastrados → arranca en el lavabo sobre encimera
      if (REQ && st.mode === 'none') { if (models.length) { st.mode = 'basin'; st.model = null; } else if (OVERTOP.length) st.mode = 'overtop'; }
      if (REQ && st.mode === 'basin' && (!st.model || models.indexOf(st.model) < 0)) st.model = firstSellableModel() || models[0] || null;
      // la selección restaurada puede no existir en el juego del modelo — ni respetar los ejes que
      // los toggles fuerzan (p.ej. un 2 senos guardado antes de activar hide_senos)
      if (st.mode === 'basin' && st.model) {
        // con enlace de la PLP se fijan sus ejes; si este mueble no monta esa combinacion, arranque normal
        if (deepFixed && pickCombo(activeModel(), deepFixed, readSize())) reconcile(deepFixed); else reconcile({});
        applyForced();
      }
      reconcileTop();                           // ídem: la talla de arranque puede no tener encimera
      reconcileOvertop();                       // BL-125: ídem para el lavabo sobre encimera
      renderModes(); renderModels();
      // re-abre el panel si había un lavabo elegido. `bl-no-anim` evita que el swap del grouping
      // reproduzca la animación de apertura: el panel debe aparecer YA abierto en el primer paint,
      // no cerrarse y volver a abrirse (2026-08-05).
      if (st.mode === 'basin' && st.model) elWrap.classList.add('bl-no-anim', 'is-open');
      renderPanel(); resolve();
      // 2026-07-29: alcance inicial de la galería CON reintentos — en móvil media-gallery inicializa
      // en diferido (Motion.inView) DESPUÉS de este init y puede reconstruir sus slides; sin
      // reintentos la primera carga se quedaba con las N slides sin filtrar. Idempotente.
      applyGalleryScope();
      var raf0 = win.requestAnimationFrame || function (f) { win.setTimeout(f, 16); };
      // devuelve la animación al panel una vez pintado el estado restaurado. El reflow forzado
      // fija el estado abierto ANTES de reactivar la transición; sin él el navegador podría
      // agrupar ambos cambios y animar igualmente.
      if (elWrap.classList.contains('bl-no-anim')) {
        raf0(function () { void elWrap.offsetHeight; elWrap.classList.remove('bl-no-anim'); });
      }
      raf0(function () { raf0(applyGalleryScope); });
      win.setTimeout(applyGalleryScope, 350);
      win.setTimeout(applyGalleryScope, 900);
      win.requestAnimationFrame ? win.requestAnimationFrame(updateProgress) : updateProgress();
    }

    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
    doc.addEventListener('bl:grouping:swapped', init);
  }

  return { senosNum: senosNum, findWb: findWb, variantKey: variantKey, optAvailable: optAvailable, addedVariantIds: addedVariantIds, requiredBlock: requiredBlock, __boot: __boot };
});
